<template>
  <div>
    <v-dialog width="400" v-model="RAPresetDialog">
    <v-card>
        <v-card-title>
            Preset Config
        </v-card-title>
        <v-card-text>
            <v-text-field v-model="RAPresetTab.Preset_Name" label="Preset Name"
            />
            <v-textarea v-model="RAPresetTab.Preset_Description" label="Description"
            />
            <v-select v-model="RAPresetTab.Category" label="Category" :items="ContentBlockClasses"
            />
            <v-select v-if="RAAdmin" v-model="RAPresetTab.Database" label="Database" :items="['Client','RA Presets']"
            />
             
        </v-card-text>
        <v-card-actions>
            <v-btn dark color="warning" @click="CancelRAPresetDialog()">
                Cancel
            </v-btn>
            <v-spacer>
            </v-spacer>
            <v-btn dark color="success" @click="SaveRAPreset()"
            >Save</v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>
    <v-dialog v-model="BulkContentBlocktoPresetDialog" width="400">
        <v-card
    class="mx-auto"
    max-width="500"
  >
    <v-card-title class="text-h6 font-weight-regular justify-space-between">
      <span>{{ currentTitle }}</span>
      <v-avatar
        color="primary lighten-2"
        class="subheading white--text"
        size="24"
        v-text="BulkContentPresetStep"
      ></v-avatar>
    </v-card-title>

    <v-window v-model="BulkContentPresetStep">
        <v-window-item :value="1">
        <v-card-text>
          <v-progress-circular
            indeterminate
            color="primary"
            ></v-progress-circular>
        </v-card-text>
        
      </v-window-item>
      <v-window-item :value="2">
        <v-card-text>
           <v-text-field v-model="RAPresetTab.Preset_Name" label="Preset Name"
            />
            <v-textarea v-model="RAPresetTab.Preset_Description" label="Description"
            />
            <v-select v-model="RAPresetTab.Category" label="Category" :items="ContentBlockClasses"
            />
        </v-card-text>        
      </v-window-item>
       <v-card-actions>
            <v-btn dark color="warning" @click="CancelRAPresetDialog()">
                Cancel
            </v-btn>
            <v-spacer>
            </v-spacer>
            <v-btn dark color="success" @click="AdvanceContentBlocktoPresetDial()"
            >Save</v-btn>
        </v-card-actions>
    </v-window>
        </v-card>
    </v-dialog>
      <v-dialog max-width="350" v-model="SEOBasicsDialog">
        <v-card tile flat width="100%">
            <v-card-title>
            </v-card-title>
            <v-card-text>
                <v-switch label="Page Shows on Web Searches" v-model="SEOPage.SEO"
                />
                <ContentEditableField style="padding:15px;"
                :FieldObject="SEOPage" :FieldName="'Overview'"
                :FieldValue="SEOPage.Overview" @UpdateContentEditableField="UpdateContentEditableField" :AdditionalSaveMethod="''" />
                <v-combobox
                        v-model="SEOPage.KeyWords"
                        :items="KeyWords"
                        label="KeyWords"
                        multiple
                        chips
                        >
                </v-combobox>
            </v-card-text>
            <v-card-text  v-if="SEOPage.SEO">
                Web Preview
                <v-list-item style="width:100%;padding-top:10px;padding-left:20px;border: 1px solid #ccc !important;" three-line> 
                                       
                    <v-list-item-content>
                        <v-list-item-title class="caption" style="margin-bottom:-6px;">{{DefaultPath+SEOPage.PageRoute}}</v-list-item-title>
                        <v-list-item-subtitle class="text-h7">
                        <v-btn  class="underlinehover" style="padding-left:0px;text-transform: capitalize;font-size: 0.925em;color: #1a0dab!important;" text plain depressed>
                            <span>{{System.Name}} || </span>
                        <span v-if="ActiveGroup && IsGroupView">{{ActiveGroup.name}} || </span> {{SEOPage.Name}} <v-icon color="#1a0dab" small dark>{{SEOPage.PageIcon}}</v-icon></v-btn>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle style="display: block;" v-html="SEOPage.Overview">
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="DeactivateSEODialog()" dark color="warning">
                    Cancel</v-btn>
                    <v-spacer>
                    </v-spacer>
                    <v-btn  @click="UpdateSEOBasics()"  dark color="success">
                        Save
                    </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-navigation-drawer :app="!MiniView" hide-overlay :color="$vuetify.theme.dark ? '' : '#ecd5e0'"
                    mini-variant v-model="SiteDialog" :class="$vuetify.theme.dark ? 'RAWebBtnGraddark' : ''"
                    :permanent="!MiniView || MiniView && SiteDialog" mini-variant-width="100"
                    :style="!DataSingleBuilder || $route.name === 'SystemConfig'? 'z-index:8;height: 100%;top:65px;position: fixed;'
                    : 'z-index:2;height: 100%;top:60px;position: fixed;'"
                   >	
                    <v-list-item class="px-2">
                    <v-list-item-avatar>
                    <v-img :src="ActiveGroup && ActiveGroup.logo ? ActiveGroup.logo : require('@/assets/logo.png')"></v-img>
                    </v-list-item-avatar>
                </v-list-item>
                <v-divider></v-divider>
                <v-list dense >
                    <v-layout class="justify-center" style="padding:20px;" row>
                    <ProgressItem :ActiveProgressItem="ComputedWebsiteProgressChecker"
                    @AdvanceSetupStep="AdvanceSetupStep" @RegressStep="RegressStep"
                    @UpdateAutoStep="UpdateAutoStep" @onPhotoUpload="onPhotoUpload"
                    :step="step" @ActivateProgressSheet="ActivateProgressSheet" @CancelProgressSheet="CancelProgressSheet"
                    />
                    </v-layout>
                     <v-list-item
                    v-for="main in FilteredTopItems"
                    :key="main.itemObjKey"
                    link
                    >
                     <v-btn @click="ActivateSelectedMain(main)">
                        <v-icon>{{main.icon}}</v-icon>
                            <v-badge color="warning" v-if="main.notifications" left>
                        <span slot="badge"> {{main.notifications}}</span>
                        </v-badge>
                    </v-btn>
                    </v-list-item>
                    <v-list-item
                    v-for="main in Computedsitenavitems"
                    :key="main.itemObjKey"
                    link
                    >
                     <v-btn dark :color="$vuetify.theme.dark ? '#c4629e' : ''" :class="$vuetify.theme.dark ? '' : 'RAWebBtnGradlight'" @click="ActivateSelectedMain(main)">
                        <v-icon >{{main.icon}}</v-icon>
                            <v-badge color="warning" v-if="main.notifications" left>
                        <span slot="badge"> {{main.notifications}}</span>
                        </v-badge>
                    </v-btn>
                    </v-list-item>
                    
                </v-list>
                </v-navigation-drawer>
                <!-- here in fact if app styling width become width: 400px; -->
             <v-navigation-drawer :right="MainDialRight"  :app="MiniView || SelectedMain.title === 'Plugins'" :class="SelectedMain.title === 'Plugins' ? 'background elevation-2' : 'elevation-2'" 
             :style="MainDialStyling" v-if="SelectedMainDialog && SelectedMain.title !== 'Add Content'" v-model="SelectedMainDialog">
                <v-list v-if="SelectedMain"> 
                       
                     <v-card flat  v-if="SelectedMain.PreDialog">
                         <v-card-title class="settingsfont">
                               {{SelectedMain.title}}<v-spacer></v-spacer><v-icon @click="SelectedMain = ''">mdi-chevron-left</v-icon>
                            </v-card-title>                            
                            <v-card-text class="settingsfont" v-if="SelectedMain.IMG">
                                <v-img :src="SelectedMain.IMG"/>
                            </v-card-text>
                            <v-card-text class="settingsfont" v-html="SelectedMain.Writeup">
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer>
                                </v-spacer>
                                <v-btn @click="ActivateSelectedMain(SelectedMain,true)">
                                Go
                                </v-btn>
                            </v-card-actions>
                     </v-card>            
                        <v-card flat  v-if="!SelectedMain.PreDialog">
                            <v-card-title class="settingsfont">
                                {{SelectedMain.title}}<v-spacer></v-spacer><v-icon @click="SelectedMain = ''">mdi-chevron-left</v-icon>
                            </v-card-title>
                             <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Web Forms'">
                                 <v-list class="transparent">
                                     <!-- uhm little something jsut asking. we don't want any quick config on web forms? -->
                                        <v-list-item style="padding-left: 0px;">
                                            <v-chip @click="NavigatetoWebFormBuilder()" >Add Web Form <v-icon>mdi-plus</v-icon></v-chip>
                                        </v-list-item>
                                        <v-list-item @click="NavigatetoWebFormEditor(webform.id)"
                                        dense v-for="webform in WebForms" :key="webform.itemObjKey"
                                        :style="'border: 1px solid #89bcd9 !important;border-radius: 6px;cursor: all-scroll !important;color: links !important;'"
                                        >
                                        {{webform.DisplayName}}
                                        </v-list-item>
                                 </v-list>
                            </v-card-text>
                            <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Page Layout'">
                                <v-list dense class="transparent">					
                                    <v-list v-for="(tab,i) in PageTabs" :key="tab.itemObjKey">									
                                    <v-list-item									
                                    @dragover.prevent @drop.prevent="Tabdragfinish(i, $event)">									
                                        <v-list-item-avatar size="20">									
                                                    <v-icon v-if="tab.Elements && tab.Elements.length>0" small style="display:block;" :id="i+'ShowElementsConfig'" @click="ShowTabElements(i)">mdi-chevron-down</v-icon>									
                                                    <v-icon small style="display:none;" :id="i+'HideElementsConfig'" @click="HideTabElements(i)">mdi-chevron-up</v-icon>									
                                                </v-list-item-avatar>									
                                        <v-list-item-title  :draggable="true" @dragstart="Tabdragstart(tab,i, $event)" @click="OpenDialog(tab,i)">{{tab.Name? tab.Name : tab.DataViewName}}</v-list-item-title>									
                                            <v-list-item-avatar v-if="userIsAdmin" size="20" @click.prevent="AddRAPresetDialog(tab)">									
                                                    <v-icon small class="links--text actionicon">mdi-content-save</v-icon>									
                                                </v-list-item-avatar>									
                                               <v-list-item-avatar size="20" @click.prevent="AdjustRowAmount(tab,i)">									
                                                    <v-icon small class="links--text actionicon">mdi-plus-thick</v-icon>									
                                                </v-list-item-avatar>  									
                                                									
                                    </v-list-item>									
                                    <v-list :id="i+'ElementsConfig'" style="display:none;padding-left:40px;">	
<!-- removed ,ShowTabElements(i) to not conflict with "OpenDialog-->
                                                <v-list-item									
                                                    @click="OpenDialog(elmnt,elmntindex,true,i)"									
                                                    v-for="(elmnt, elmntindex) in tab.Elements"									
                                                    :key="elmnt.itemObjKey"									
                                                    link									
                                                    @dragover.prevent @drop.prevent="Elmntdragfinish({tab:tab,i:i,elmnt:elmnt,elmntindex:elmntindex})"									
                                                >									
                                                    <v-list-item-title v-text="elmnt.Name? elmnt.Name : elmnt.DataViewName"									
                                                    :draggable="true" @dragstart="Elmntdragstart(tab,i,elmnt,elmntindex, $event)"></v-list-item-title>									
									
                                                    <v-list-item-icon>									
                                                    <v-icon class="blue--text" v-text="elmnt.Icon"></v-icon>									
                                                    </v-list-item-icon>									
                                                </v-list-item>									
                                    </v-list>									
                                    </v-list>		
                                </v-list>
                            </v-card-text>
                            <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Site Info' && SelectedNavbar">
                                <v-img :src="ActiveGroup && ActiveGroup.logo ? ActiveGroup.logo : System && System.Logo ? System.Logo : require('@/assets/logo.png')">
                                 <v-row v-if="!ActiveGroup" style="left: 12px;position: absolute; bottom: 40px;width: 100%;height:50px;padding-top:10px;background: linear-gradient(180deg, rgba(222,221,221,0.5) 0%, rgba(222,221,221,0.5) 100%);">
                            
                                    <v-chip style="cursor: pointer;"  @click="ActivateGalleryDialog('SiteLogo')" :class="$vuetify.theme.dark ? 'mx-3' : 'white mx-3'">Change</v-chip>
                                </v-row>
                                </v-img>
                            <p>Update Contact Information and other basic information for your Site</p>
                            <v-card-actions class="justify-end">
                                <v-btn dark color="success" @click="ActiveSiteInfoDialog()">go</v-btn>
                            </v-card-actions>
                            </v-card-text>
                            <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Site Menu & Pages' || SelectedMain.title === 'Site Menu & Pages' && IsGroupView">
                              
                                <v-overflow-btn style="width:200px;padding-top:5px;"
                                :items="NavbarItems" :placeholder="'Navbar: '+SelectedNavbar.Name" v-model="SelectedNavbar"
                                item-text="Name"
                                    class="elevation-0 noborderoverflow"
                                    dense return-object
                                    ></v-overflow-btn>
                                    <v-list class="transparent">
                                        <v-list-item style="padding-left: 0px;">
                                            <v-chip @click="AddNewPage(SelectedNavbar)" >Add Page <v-icon>mdi-plus</v-icon></v-chip>
                                            <v-chip @click="UpdateMenu()" dark color="success"><v-icon>mdi-content-save</v-icon>Save
                                            </v-chip>
                                        </v-list-item>
                                <v-list-item  @change="SelectOtherPage(page)" :class="PageClass(page)" @dragend="CancelNavItemDrag()"
                                 @dragover.prevent  @drop.prevent="page.OnMenu ? NavItemDragFinish(pageindex, $event) : ''"									
                                :draggable="page.OnMenu" @dragstart="NavItemDragStart(pageindex, $event)"
                                dense v-for="(page,pageindex) in ComputedNavbarPages" :key="page.itemObjKey"
                                :style="SelectedPage.Name === page.Name ? 'border: 1px solid #89bcd9 !important;border-radius: 6px;cursor: all-scroll !important;color: links !important;'
                                : 'border: 1px solid #eee !important;border-radius: 6px;cursor: all-scroll !important;color: links !important;'"
                                >
                                
                                <v-list-item-avatar class="sitenavitembtns" style="margin-right: 0px !important;" size="20">
                                         <v-icon  small>mdi-drag</v-icon> 
                                    </v-list-item-avatar>
                                    <v-list-item-avatar style="margin-right: 0px !important;" size="20">
                                         <v-icon small>{{page.PageIcon}}</v-icon> 
                                    </v-list-item-avatar>
                                    <v-list-item-content style="padding: 4px;" :class="page.RenderStyling" >
                                        <span v-if="page.Name.length > 18">
                                      {{page.Name.substr(0,15)}}...
                                        </span>
                                        <span v-else>
                                             {{page.Name}}
                                        </span>
                                    </v-list-item-content>
                                    <v-list-item-actions>
                                        <v-icon v-if="page.MenuIndex === 100000" small>mdi-eye-off-outline</v-icon>
                                        <v-icon v-if="page.MenuIndex !== 100000" small>mdi-eye</v-icon>
                                        
                                    </v-list-item-actions>
                                    <v-list-item-actions>
                                        <v-menu nudge-right="30"								
                                            :close-on-content-click="false"                            									
                                            transition="scale-transition"                            									
                                            >									
                                            <template v-slot:activator="{ on }">	
                                            <v-btn 
                                            v-on="on"
                                            icon fab small
                                            >
                                             <v-icon small>mdi-dots-horizontal-circle-outline</v-icon>
                                            </v-btn>
                                            </template>
                                            <v-card flat width="150">
                                                <v-list style="padding: 0px;" dense class="transparent">
                                                    <v-list-item class="settingsfont" dense @click="page.MenuIndex === 100000 ? PushPagetoNavlistArray(page) :RemovePagefromNavlistArray(page)">
                                                        <v-icon style="padding:5px;" size="15">
                                                            {{page.MenuIndex === 100000 ? 'mdi-eye' : 'mdi-eye-off'}}
                                                        </v-icon>
                                                        {{page.MenuIndex === 100000 ? 'Show' : 'Hide'}}
                                                    </v-list-item>
                                                    <v-list-item @click="TogglePageMenuOnly(page)" class="settingsfont" dense v-if="page.Children && page.Children.length > 0">
                                                        <v-icon style="padding:5px;" size="15">
                                                            {{page.MenuOnly ? 'mdi-toggle-switch-off-outline' : 'mdi-toggle-switch'}}
                                                        </v-icon>
                                                        {{page.MenuOnly ? 'Page' : 'Menu Only'}}
                                                    </v-list-item>
                                                    <v-list-item @click="UpdatePublicLandingPage(page)" class="settingsfont" dense v-if="!System.Public_Landing_Page && WebsiteBuilderView ||
                                                    System.Public_Landing_Page && System.Public_Landing_Page !== '/'+page.Name.split(' ').join('-') && WebsiteBuilderView">
                                                        <v-icon style="padding:5px;" size="15">
                                                             mdi-home
                                                        </v-icon>
                                                        Make Root
                                                    </v-list-item>   
                                                    <v-list-item class="settingsfont" @click="PushtoPreviousNavItem(page,pageindex)"
                                                     dense v-if="page.MenuIndex !== 100000">
                                                        <v-icon style="padding:5px;" size="15">
                                                             mdi-subdirectory-arrow-right
                                                        </v-icon>
                                                        Subpage
                                                    </v-list-item>  
                                                      <v-list-item @click="PushPageUpwards(page,pageindex)" class="settingsfont" dense v-if="page.SubPage && page.MenuIndex !== 100000">
                                                        <v-icon style="padding:5px;" size="15">
                                                             mdi-subdirectory-arrow-left
                                                        </v-icon>
                                                        Push up
                                                    </v-list-item>                                                     
                                                    <v-menu nudge-left="100"								
                                                        :close-on-content-click="false"                            									
                                                        transition="scale-transition"                            									
                                                        >									
                                                        <template v-slot:activator="{ on }">
                                                            <v-list-item v-on="on" class="settingsfont" dense>
                                                                <v-icon style="padding:5px;" size="15">
                                                                    mdi-pencil
                                                                </v-icon>
                                                                Rename
                                                            </v-list-item>
                                                        </template>
                                                        <v-card>
                                                            <v-card-title class="settingsfont">
                                                               Rename<v-spacer></v-spacer>
                                                               <v-btn dark color="success" small @click="UpdatePageProp(page,'Name')">Save</v-btn>
                                                            </v-card-title>
                                                            <v-card-text>
                                                                <v-text-field label="Page Name" v-model="page.Name"
                                                                />
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-menu>
                                                    <v-menu nudge-left="100"								
                                                        :close-on-content-click="false"                            									
                                                        transition="scale-transition"                            									
                                                        >									
                                                        <template v-slot:activator="{ on }">
                                                            <v-list-item v-on="on" class="settingsfont" dense>
                                                                <v-icon style="padding:5px;" size="15">
                                                                    mdi-link
                                                                </v-icon>
                                                                Path
                                                            </v-list-item>
                                                        </template>
                                                        <v-card>
                                                            <v-card-title class="settingsfont">
                                                               Path<v-spacer></v-spacer>
                                                               <v-btn dark color="success" small @click="UpdatePageProp(page,'PageRoute')">Save</v-btn>
                                                            </v-card-title>
                                                            <v-card-text>
                                                                <v-text-field label="Page Path" v-model="page.PageRoute"
                                                                />
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-menu>
                                                    <v-menu nudge-left="100"								
                                                        :close-on-content-click="false"                            									
                                                        transition="scale-transition"                            									
                                                        >									
                                                        <template v-slot:activator="{ on }">
                                                            <v-list-item v-on="on" class="settingsfont" dense>
                                                                <v-icon style="padding:5px;" size="15">
                                                                    mdi-circle
                                                                </v-icon>
                                                                Icon
                                                            </v-list-item>
                                                        </template>
                                                        <v-card>
                                                            <v-card-title class="settingsfont">
                                                               Icon
                                                               <v-spacer></v-spacer>
                                                               <v-btn dark color="success" small @click="UpdatePageProp(page,'PageIcon')">Save</v-btn>
                                                            </v-card-title>
                                                            <v-card-text>
                                                                <v-text-field label="Page Icon" v-model="page.PageIcon"
                                                                />
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-menu>
                                                    <v-list-item class="settingsfont" dense @click="ActivateSEOBasicsDialog(page)">
                                                        <v-icon style="padding:5px;" size="15">
                                                            mdi-search-web
                                                        </v-icon>
                                                        SEO Basics
                                                    </v-list-item>
                                                    
                                                    <v-list-item class="settingsfont" dense>
                                                        <v-icon color="red" style="padding:5px;" size="15">
                                                            mdi-delete-forever
                                                        </v-icon>
                                                        Delete
                                                    </v-list-item>
                                                    <!-- <v-list-item @click="ConfirmPageTransfer(page)" class="settingsfont" dense>
                                                        <v-icon color="red" style="padding:5px;" size="15">
                                                            mdi-transfer
                                                        </v-icon>
                                                        Transfer
                                                    </v-list-item> -->
                                                </v-list>
                                            </v-card>
                                        </v-menu>
                                     
                                     </v-list-item-actions>
                                </v-list-item>
                                    </v-list>
                            </v-card-text>
                            
                            <v-card-text class="settingsfont" v-if="SelectedMain.title === 'App Styling'">
                                <AppStylingComponent :DisableNavbarSelect="true" :SystemPhotoLibraries="SystemPhotoLibraries" v-if="!IsGroupView"
                                :GradientElements="GradientElements" :SystemEntities="SystemEntities"
                                :ActiveNavbar="ActiveAppStylingNavbar" :GraphicalElements="GraphicalElements" :System="System"
                                @SetColorstoSystemColors="SetColorstoSystemColors"
                                />
                                <v-list  v-if="IsGroupView">
                                    <v-list-item dense>
                                        Site Logo
                                    </v-list-item>
                                    <v-list-item dense>
                                        <v-btn
                                        dark x-small
                                        color="#e4003b"
                                        class="font-weight-light"
                                        @click="PrepareActivateFullGallery('NavBar_IMG')"
                                        >Change Picture</v-btn>
                                    </v-list-item>
                                    <v-img class="black" v-if="ActiveGroup.NavBar_IMG"
                                    :src="ActiveGroup.NavBar_IMG.Path"
                                    />
                                    <v-img class="black" v-if="!ActiveGroup.NavBar_IMG"
                                     src="@/assets/ImageHolder.png"
                                    />
                                   <v-list-item>
                                        Navbar BG Color
                                        <v-menu
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="200px"
                                            >
                                            <template v-slot:activator="{ on }">
                                                <v-icon v-on="on">mdi-palette-advanced</v-icon>
                                            </template>
                                            <v-color-picker v-model="ActiveGroup.NavbarBGColor"></v-color-picker>
                                            </v-menu>
                                        </v-list-item>
                                        <v-list-item>
                                        Navbar Text Color
                                        <v-autocomplete
                                            :items="LibraryColors"
                                            label="Nav Items Text Color"
                                            v-model="ActiveGroup.NavbarTextColor"
                                        >
                                            <template v-slot:item="{ item }">
                                            <span :class="item"
                                                >{{ item }}
                                                <p style="font-size: 12px">
                                                The Quick brown fox jumps over the lazy dog
                                                </p>
                                            </span>
                                            </template>
                                        </v-autocomplete>
                                        </v-list-item>
                                        <v-list-item>
                                        <v-autocomplete
                                            :items="AdvancedComputedLibraryColors"
                                            label="Nav Items BG Color"
                                            v-model="ActiveGroup.NavItemsBGColor"
                                        >
                                            <template v-slot:item="{ item }">
                                            <span :class="item"
                                                >{{ item }}
                                                <p style="font-size: 12px">
                                                The Quick brown fox jumps over the lazy dog
                                                </p>
                                            </span>
                                            </template>
                                        </v-autocomplete>
                                        </v-list-item>
                                        <v-list-item>
                                        <v-autocomplete
                                            :items="LibraryColors"
                                            label="Nav Items Text Color"
                                            v-model="ActiveGroup.NavItemsTextColor"
                                        >
                                            <template v-slot:item="{ item }">
                                            <span :class="item"
                                                >{{ item }}
                                                <p style="font-size: 12px">
                                                The Quick brown fox jumps over the lazy dog
                                                </p>
                                            </span>
                                            </template>
                                        </v-autocomplete>
                                        </v-list-item>
                                        
                                        <v-list-item>
                                        <v-select item-text="Name" :items="SystemAssets" v-model="ActiveGroup.NavBar_IMG" return-object>
                                        <template v-slot:item="{ item }">
                                            <span>
                                            <v-img height="50" :src="item.ThumbURL"/>
                                            </span>
                                            </template>
                                        </v-select>
                                        </v-list-item>
                                        <v-list-item class="justify-end">
                                            <v-btn @click="UpdateGroupStyling()" dark color="success">
                                                Save
                                            </v-btn>
                                        </v-list-item>
                                </v-list>
                                <!-- the trick is not only that both dbbuilderview and websitebuilder share this component, the real trick is the amount of styling applicable -->
                                <!-- Home do we sensefully replicate this crap? -->
                                <!-- How about we take the appstyling component and upgrade it? make it a callable component push the navigation view etc? -->
                            </v-card-text>
                            <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Page Design'">
                                <v-list-item>
                                    <v-text-field  v-model="EditedPage.PageOverlay" label="Page Overlay"/>
                                </v-list-item>
                                 <v-list-item>
                                    <v-btn @click="AssignSocialItemInteractMethod('UpdatePageOverlay',EditedPage.PageOverlay)">Update</v-btn>
                                </v-list-item>
                                 <v-list-item>
                                    <v-text-field  v-model="EditedPage.PageCustomStyle" label="Custom Style"/>
                                </v-list-item>
                                 <v-list-item>
                                    <v-btn @click="AssignSocialItemInteractMethod('UpdatePageCustomStyle',EditedPage.PageCustomStyle)">Update</v-btn>
                                </v-list-item>
                                <v-list-item>
                                    <v-switch @change="AssignSocialItemInteractMethod('UpdateClearNavbarColor',EditedPage.ClearNavbarColor)" v-model="EditedPage.ClearNavbarColor" label="Clear Navbar Color"/>
                                </v-list-item>
                                <v-list-item @click="ActivatePageBGDialog()" >
                                <span v-if="EditedPage.PageBGAsset" style="--col: #04AA6D"  class="texbtn btnhover elevation-1">
                            <v-icon style="--col: #04AA6D"  class="btnhover" small>mdi-file</v-icon>Change BG Image
                            </span><span v-if="!EditedPage.PageBGAsset" style="--col: #04AA6D"  class="texbtn btnhover elevation-1">
                                <v-icon style="--col: #04AA6D"  class="btnhover" small>mdi-file</v-icon>Select BG Image
                            </span>
                                </v-list-item>
                            <v-select @change="AssignSocialItemInteractMethod('UpdatePageHeadersFont',EditedPage.PageHeadersFont)" v-model="EditedPage.PageHeadersFont" label="Headers Font"                                  
                                :items="ComputedFontOptions">
                                <template v-slot:item="{ item }">
                                    <span :style="'font-family:'+item">{{item}}
                                        <p style="font-size:12px;">The Quick brown fox jumps over the lazy dog
                                        </p>
                                        </span>
                                </template>
                                <template v-slot:selection="{ item }">
                                    <span :style="'font-family:'+item">{{item}}</span>
                                </template>
                                </v-select>
                                <v-select @change="AssignSocialItemInteractMethod('UpdatePageContentFont',EditedPage.PageContentFont)" v-model="EditedPage.PageContentFont" label="Body Font"                                   
                                    :items="ComputedFontOptions">
                                <template v-slot:item="{ item }">
                                    <span :style="'font-family:'+item">{{item}}
                                        <p style="font-size:12px;">The Quick brown fox jumps over the lazy dog
                                        </p>
                                        </span>
                                </template>
                                <template v-slot:selection="{ item }">
                                    <span :style="'font-family:'+item">{{item}}</span>
                                </template>
                                </v-select>	
                                <v-select label="Header size" @change="AssignSocialItemInteractMethod('UpdatePageHeadersFontSize',EditedPage.PageHeadersFontSize)"
                                v-model="EditedPage.PageHeadersFontSize" :items="[24,36,42,50]"									
                                    />	
                            <v-divider vertical></v-divider>
                            <!-- <v-menu nudge-top="30" nudge-right="30" max-width="350"								
                            :close-on-content-click="false"                            									
                            transition="scale-transition"                            									
                            >									
                            <template v-slot:activator="{ on }">
                            <v-list-item v-on="on" dense class="RAWebBtnGraddarksoft">
                                BG Color
                            </v-list-item>
                            
                            </template>
                            <v-card tile flat>
                                <v-row >
                                <v-virtual-scroll class="RAWebBtnGraddarksoft"
                                    :items="CSSColorswithChildren"
                                    :height="200"
                                    item-height="60" 
                                                     
                                >
                                <template v-slot:default="{ item }">
                                    <v-list-item class="justify-center" style="padding: 5px;">
                                        <v-list-item-avatar v-for="child in item.Children" :key="child.itemOnJkey">
                                       <v-tooltip bottom max-width="200">
                                            <template v-slot:activator="{ on, attrs }">
                                         <v-avatar v-on="on" v-bind="attrs" :style="'background-color: '+child+';'">
                                        </v-avatar>
                                            </template>
                                            <span>{{child}}</span>
                                        </v-tooltip>
                                        </v-list-item-avatar>
                                    </v-list-item>
                                </template>
                                </v-virtual-scroll>
                                </v-row>
                            </v-card>
                            </v-menu> -->
                             <v-autocomplete @change="AssignSocialItemInteractMethod('UpdatePageBGColor',EditedPage.PageBGColor)"
                             :items="$store.state.CSSColors" clearable label="Page BG Color" item-text="Name" v-model="EditedPage.PageBGColor"
                                        >
                                    <template v-slot:item="data">
                                        <v-list-item-avatar>
                                        <v-avatar :style="'background-color: '+data.item+';'">
                                        </v-avatar>
                                        </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-subtitle v-html="data.item"></v-list-item-subtitle>
                                            </v-list-item-content>
                                            </template>
                                        </v-autocomplete>
                                    <!-- <v-autocomplete @change="AssignSocialItemInteractMethod('UpdatePageBGColor',EditedPage.PageBGColor)"
                                    :items="STDCSSColors" clearable label="Page BG Color" item-text="Name" v-model="EditedPage.PageBGColor">
                                        <template v-slot:item="{ item }">
                                            <span :style="'background-color:'+item.HEX">{{item.Name}}
                                                <p style="font-size:12px;">The Quick brown fox jumps over the lazy dog
                                                </p>
                                                </span>
                                        </template>
                                    </v-autocomplete> -->
                            <v-spacer></v-spacer>
                                <v-list-item>
                                    <v-text-field label="Page BG Gradient"
                                     @change="AssignSocialItemInteractMethod('UpdatePageBGGradient',EditedPage.PageBGGradient)"
                                     clearable v-model="EditedPage.PageBGGradient"/>
                                </v-list-item>
                                <v-list-item>									
                                    <a href="https://cssgradient.io/" target="_blank">Get Code</a>	
                                </v-list-item>
                            </v-card-text>
                            <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Media'">
                                <AssetsDirectory :Assets="SystemAssets" :Cols="6" :HoverPreview="true" @ActivateFullGallery="ActivateFullGallery" :ViewFullGalleryBottom="true"
                                :HideSelect="true" :Slice="6"
                                 :ViewFullGalleryText="'See More'"
                                />
                                
                            </v-card-text>
                            <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Plugins'">
                                <RAPluginCarousel :System="System"
                                :AppisDarkMode="AppisDarkMode" class="my-3" :GuideList="DataSingleBuilder ? AppPluginsMatched(['Database Builder','DBB']) : RAPluginsMatched(['Website Builder','WB'])" :tab="systemguideelmnt"
                                :ListPreviewOnly="true"
                                 />
                            </v-card-text>
                        </v-card>
                    </v-list>
                </v-navigation-drawer>
                <v-navigation-drawer  color="#f3e5ec" temporary id="selectedmaindial" :right="MainDialRight" :app="MiniView || SelectedMain.title === 'Plugins'" :class="'elevation-2'" 
             :style="MainDialStyling+'padding-bottom: 100px;'" width="400" v-model="SelectedMainDialog" v-if="SelectedMainDialog && SelectedMain.title === 'Add Content'">
            <v-tabs>
                <v-tab>Factory</v-tab>
                <v-tab-item>
                    <v-list dense class="transparent" v-if="SelectedMain && !ActiveBlockClass && DataSingleBuilder">
                    <v-list-item v-for="tab in DataViewTabs" :key="tab.itemObjKey" @click="AddContentBlock(tab,true)">
                        {{tab.DataViewName}}
                    </v-list-item>
                    </v-list>
             <v-list dense class="transparent" v-if="SelectedMain && !ActiveBlockClass">  
                <v-card class="transparent" flat style="padding-left: 10px;" v-if="!SelectedMain.PreDialog">
                            <v-card-title class="settingsfont">
                                {{SelectedMain.title}}<v-spacer></v-spacer><v-icon @click="SlidebackDialog()">mdi-chevron-left</v-icon>
                            </v-card-title>
                    <v-list-item class="settingsfont" style="text-transform: uppercase;font-weight:500;" dense @click="ActivateActiveBlockClass(clss)" v-for="clss in ContentBlockClasses" :key="clss.itemObjKey">
                        {{clss}}
                    </v-list-item>  
                </v-card>
             </v-list>

             
             <!-- <v-slide-x-transition > -->
                <v-expand-x-transition>
                <v-list style="left:-400px;" v-if="SelectedMain && ActiveBlockClass" class="transparent">  
                    <v-card style="padding: 0px;" flat  v-if="!SelectedMain.PreDialog" class="transparent">
                        <v-card-title class="settingsfont">
                                {{ActiveBlockClass}}<v-spacer></v-spacer><v-icon style="z-index:20;" @click="ActiveBlockClass = ''">mdi-chevron-left</v-icon>
                        </v-card-title>
                        <!-- <v-btn @click="AddalltoRADB()">Add</v-btn> -->
                        <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Add Content'">
                            <v-list dense style="padding: 0px;padding-top:15px;" v-for="tab in PreviewedContentblocks" :key="tab.itemObjKey">
                                <v-list-item dense class="overline">
                                   <v-avatar tile size="35">
                                            <v-icon size="35">{{tab.Icon}}</v-icon>
                                        </v-avatar> {{tab.Preset_Name}}
                                </v-list-item>
                                <v-list-item class="RAWebBtnGradlightsoft" dense style="padding: 0px;max-height: 350px;min-height: 200px;border-radius: 15px;" @click="AddContentBlock(tab)">
                                <PageTabRenderer  :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                                :PageHeadersFontSize="PageHeadersFontSize" style="padding-top:30px;" :System="System" :SystemEntities="SystemEntities"
                                :tab="tab" :i="i" :downsized="true" :SampleOnly="true"
                                />
                                </v-list-item>
                            </v-list>
                        </v-card-text>
                    </v-card>
                    </v-list>
                </v-expand-x-transition>
                </v-tab-item>
                <v-tab>My Stored Tabs
                </v-tab>
                <v-tab-item>
                    <v-list style="left:-400px;" v-if="SelectedMain" class="transparent">  
                    <v-list-item  @click="AddContentBlock(tab,true)" v-for="tab in StorePagePresets" :key="tab.itemObjKey">
                        <v-list-item-content>
                            <v-list-item-title>
                                {{tab.Preset_Name}}
                            </v-list-item-title>
                            <v-card-subtitle>
                                {{tab.Preset_Description}}
                            </v-card-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    </v-list>
                </v-tab-item>
            </v-tabs>
             <!-- </v-slide-x-transition> -->
                 <!-- <v-btn @click="Correct()">Correct</v-btn> -->
                </v-navigation-drawer>
  </div>
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import axios from 'axios'
import format from 'date-fns/format'
import ContentEditableField from '@/components/Database/ContentEditableField'
import AssetsDirectory from '@/components/WebPages/ConfigComponents/AssetsDirectory';	
import AppStylingComponent from '@/components/SuiteBuilder/AppStylingComponent';	
import RAPluginCarousel from '@/components/WebPages/RenderComponents/RAPluginCarousel';
import PageTabRenderer from '@/components/WebPages/PageTabRenderer.vue';
import ProgressItem from '@/components/Dashboards/ProgressItem';
import FieldsForm from '@/components/Database/FieldsForm';	
export default {
    props: ['System','SystemEntities','SitePages','SocialEntities','SystemPhotoLibraries','SubscriptionPackages',
    'WebFormEntities','GroupEntities','GraphicalElements','GradientElements','RADB','Directories'],
    components: {
        ContentEditableField,
        AssetsDirectory,
        AppStylingComponent,
        RAPluginCarousel,
        PageTabRenderer,
        ProgressItem,
        FieldsForm
    },
    data() {
        return {
            NewSubOrderid: '',
            selectedPackage: '',
            Company_Address: {Name: 'Company_Address',FieldBreakdown: [],DisplayName: 'Company Address',CommonFieldType: 'Physical Address',Type: 'Common Field'},
            Billing_Address: {Name: 'Billing_Address',FieldBreakdown: [],DisplayName: 'Billing Address',CommonFieldType: 'Physical Address',Type: 'Common Field'},
            AutoStep: 1,
            AddingProfilePhoto: false,
            step: 1,
            //ComputedActiveFeaturedMember
            WebsiteProgressChecker: {title: 'Site General',ViewName: 'SiteGeneralView',icon: 'mdi-cogs',StepRequirements: [
          {Check: 1, Name: 'Company Header Info',ParentObj: 'System',Prop: {Name: 'Basic_Info',Type: 'Object',ChildProps: [
            
            {Name: 'Company_Name',DisplayName: 'Company Name',Type: 'Single Line Text'},
            {Name: 'SiteSlogan',DisplayName: 'Slogan',Type: 'Single Line Text',Optional: true},
            {Name: 'SiteEmail',DisplayName: 'Email',Type: 'Common Field',CommonFieldType: 'Email',Optional: true},
            {Name: 'SiteTelephoneNumber',DisplayName: 'Telephone Number',Type: 'Common Field',CommonFieldType: 'Telephone Number',Optional: true},
            {Name: 'Description',DisplayName: 'Description',Type: 'Multiple Lines Text',IsContentEditable: true}        
        ]},
          Toolip: `<p>This basic contact information helps people reach you.</p>`},
          {Check: 2, Name: 'Business Info',ParentObj: 'System',Prop: {Name: 'Basic_Info',Type: 'Object',ChildProps: [
            {Name: 'Business_Hours',DisplayName: 'Business Hours',Type: 'Business Hours',IsContentEditable: true}        
        ]},
          Toolip: `<p>Give some basic Business information.</p>`},
          {Check: 3, Name: 'Business Info',ParentObj: 'System',Prop: {Name: 'Basic_Info',Type: 'Object',ChildProps: [
            {Name: 'GoogleMapsLocation',DisplayName: 'Google Maps Location',Type: 'Google Maps Location',Optional: true},//Google My Maps??
        ]},
          Toolip: `<p>Give some basic Business information.</p>`},
          {Check: 4, Name: 'Menu Styling',ParentObj: 'System',Prop: {Name: 'Menu_Styling',Type: 'Object',ChildProps: [
            {Name: 'Public_Landing_Page',DisplayName: 'Default Page',Type: 'Option Set',Check: 'Present'},
            {Name: 'PublicNavbarDark',DisplayName: 'Navbar Dark',Type: 'Boolean',Optional: true},
            {Name: 'PublicNavbarStyle',DisplayName: 'Navbar Style',Type: 'Option Set',TextOnly: true,Options:['Default','STD Bar'],Optional: true},
            {Name: 'PublicNavbarText',DisplayName: 'Navbar Text',Type: 'Color Picker',Optional: true},
            {Name: 'PublicNavbarSelectedText',DisplayName: 'Selected Item Color',Type: 'Color Picker',Optional: true},
            {Name: 'PublicNavbarItemSelectBG',DisplayName: 'Selected Item BG',Type: 'Color Picker',Optional: true},
            {Name: 'PublicNavbarItemHoverBG',DisplayName: 'Hover Item BG',Type: 'Color Picker',Optional: true},
          ]},
          Toolip: `<p>Configure your Site's navigational system, and menu styling.</p>`},
          {Check: 5, Name: 'Review and Publish',ParentObj: 'System',Prop: {Name: 'Publishing',DisplayName: 'Published',Type: 'Object',
          ChildProps: [
            // {Name: 'Is_Directory_Listing',DisplayName: 'Listed',Type: 'Boolean',ReadOnly: true},
            // {Name: 'Published',DisplayName: 'Published',Type: 'Boolean'},
          {Name: 'Site_Category',DisplayName: 'Site Category',Type: 'Option Set',Options: []},
          //{Name: 'Subscription_Package'}
          ]},
          Toolip: `<p>Let's get you signed up for a Directory!</p>`},
          {Check: 6, Name: 'Listing',ParentObj: 'System',Prop: {Name: 'Listing_Info',Type: 'Object',ChildProps: [
            {Name: 'KeyWords',DisplayName: 'Keywords',Type: 'Option Set',IsMultiple: true,CanAdd: true,Checking: 'Present'},
            {Name: 'Logo',DisplayName: 'Site Picture',Type: 'Single File Upload',FeaturedPhoto: true}
          ],},
          //decided that step 1 simply let's you toggle site menu pages menu so in that case when adding pages...why not menu same time? right?
        //   Toolip: `<p>This information makes it easy for people to find you in members directory.</p>`},
        //   {Check: 4, Name: 'Menu Items',ParentObj: 'System',Prop: {Name: 'Menu_Items',Type: 'Object',ChildProps: [
        //     {Name: 'MenuItems',DisplayName: 'Menu Items',Type: 'Color',Checking: 'Length'}
        //   ]},
          Toolip: `<p>Let's finalize your Directory listing!</p>`},
          
          
          ]},
            BLANKTAB: {	
                StaticVariables: [],					
                Open: true,									
                SectionType: true,									
                Transparent: true,									
                Alignment: 'center',									
                Justify: 'justify-center',									
                RowTransparency: 'transparent',									
                Name: 'blank',									
                Elements: [],									
                ShowComponents: true,									
                FlexXLRG:11,									
                FlexLarge: 11,									
                FlexMedium: 11,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                },
            AddingBlocks: [],
            BulkContentBlocktoPresetDialog: false,
            BulkContentPresetStep: 1,
            BulkContenttoPresetIndex: -1,
            RAPresetTab: {
                Preset_Name: '',
                Database: 'Client'
            },
            DefaultRAPresetTab: {
                Preset_Name: '',
                Database: 'Client'
            },
            RAPresetDialog: false,
            PageContentFont: 'Montserrat',
            PageHeadersFontSize: 42,
            PageHeadersFont: 'Raleway',
            ContentBlockClasses: [
                'Parallax',
                'Text',
                'Titles',
                'Images',
                'Gallery',
                'Call to Action',                                
                'Lists',
                'Links',
                'Feeds',
                'Misc',
                'Graphics',
                'Custom'
            ],
            ActiveBlockClass: '',
            systemguideelmnt: {			
              HideGuidesCarousel: false,						
                RowColor: '#00ffff',									
                Name: 'System Guide',									
                ShowComponents: true,									
                Icon: 'mdi-card-text',									
                Title: 'About',									
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus. Commune scaevola imperdiet`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,		
                Elevation: 6,
                BoxTransparency: '',
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:6,									
                FlexLarge: 8,									
                FlexMedium: 10,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },
            AppStylingIMGProp: '',
            LibraryColors: [
        'red',
        'white',
        'black',
        'pink',
        'purple',
        'indigo',
        'blue',
        'light-blue',
        'cyan',
        'teal',
        'green',
        'light-green',
        'lime',
        'yellow',
        'amber',
        'orange',
        'deep-orange',
        'brown',
        'blue-grey',
        'grey'
      ],
            GalleryLibraries: [],
            FontOptions: ['Architects Daughter','Bahianita','Bangers','Bebas Neue','Berkshire Swash','Caveat','Courgette','Crimson Pro','Dancing Script','Gudea','Hind','Impact','Indie Flower','Lato','Lobster','Macondo Swash Caps','Maven Pro','Metrophobic','Michroma','Montserrat','Mulish','Mukta Vaani',
                  'News Cycle','Niramit','NTR','Nunito Sans','Orbitron','Oswald','Padauk','Palanquin','Parisienne','Playfair Display','Poiret One','Poppins','Quicksand','Raleway','Redressed','Roboto','Tangerine','Tulpen One','Verdana','Vibes','Yellowtail'],									
        
            
        SEOPage: {
            Overview: '',
            PageRoute: '',
            KeyWords: [],
            Name: '',
            PageIcon: '',
            SEO: false,
        },
        DefaultSEOPage: {
            Overview: '',
            PageRoute: '',
            KeyWords: [],
            Name: '',
            PageIcon: '',
            SEO: false,
        },
        SEOBasicsDialog: false,
        PageBasics: [
            {Label: 'Rename', Prop: 'PageName', Icon: 'mdi-pencil', Menu: false},
            {Label: 'Path', Prop: 'PageRoute', Icon: 'mdi-link', Menu: false},
            {Label: 'Rename', Prop: 'PageIcon', Icon: 'mdi-circle', Menu: false}
        ],
        NavItemIndex: -1,
        SelectedNavbar: '',
        SelectedPage: '',
        SelectedMain: '',
        SelectedMainDialog: false,
        STDCSSColors: [{Name: 'aliceblue', HEX: '#f0f8ff'},{Name: 'antiquewhite', HEX: '#faebd7'},{Name: 'aqua', HEX: '#00ffff'},{Name: 'aquamarine', HEX: '#7fffd4'},{Name: 'azure', HEX: '#f0ffff'},{Name: 'beige', HEX: '#f5f5dc'},{Name: 'bisque', HEX: '#ffe4c4'},{Name: 'black', HEX: '#000000'},{Name: 'blanchedalmond', HEX: '#ffebcd'},{Name: 'blue', HEX: '#0000ff'},{Name: 'blueviolet', HEX: '#8a2be2'},{Name: 'brown', HEX: '#a52a2a'},{Name: 'burlywood', HEX: '#deb887'},{Name: 'cadetblue', HEX: '#5f9ea0'},{Name: 'chartreuse', HEX: '#7fff00'},{Name: 'chocolate', HEX: '#d2691e'},{Name: 'coral', HEX: '#ff7f50'},{Name: 'cornflowerblue', HEX: '#6495ed'},{Name: 'cornsilk', HEX: '#fff8dc'},{Name: 'crimson', HEX: '#dc143c'},{Name: 'cyan', HEX: '#00ffff'},{Name: 'darkblue', HEX: '#00008b'},{Name: 'darkcyan', HEX: '#008b8b'},{Name: 'darkgoldenrod', HEX: '#b8860b'},{Name: 'darkgray', HEX: '#a9a9a9'},{Name: 'darkgreen', HEX: '#006400'},{Name: 'darkgrey', HEX: '#a9a9a9'},{Name: 'darkkhaki', HEX: '#bdb76b'},{Name: 'darkmagenta', HEX: '#8b008b'},{Name: 'darkolivegreen', HEX: '#556b2f'},{Name: 'darkorange', HEX: '#ff8c00'},{Name: 'darkorchid', HEX: '#9932cc'},{Name: 'darkred', HEX: '#8b0000'},{Name: 'darksalmon', HEX: '#e9967a'},{Name: 'darkseagreen', HEX: '#8fbc8f'},{Name: 'darkslateblue', HEX: '#483d8b'},{Name: 'darkslategray', HEX: '#2f4f4f'},{Name: 'darkslategrey', HEX: '#2f4f4f'},{Name: 'darkturquoise', HEX: '#00ced1'},{Name: 'darkviolet', HEX: '#9400d3'},{Name: 'deeppink', HEX: '#ff1493'},{Name: 'deepskyblue', HEX: '#00bfff'},{Name: 'dimgray', HEX: '#696969'},{Name: 'dimgrey', HEX: '#696969'},{Name: 'dodgerblue', HEX: '#1e90ff'},{Name: 'firebrick', HEX: '#b22222'},{Name: 'floralwhite', HEX: '#fffaf0'},{Name: 'forestgreen', HEX: '#228b22'},{Name: 'fuchsia', HEX: '#ff00ff'},{Name: 'gainsboro', HEX: '#dcdcdc'},{Name: 'ghostwhite', HEX: '#f8f8ff'},{Name: 'gold', HEX: '#ffd700'},{Name: 'goldenrod', HEX: '#daa520'},{Name: 'gray', HEX: '#808080'},{Name: 'green', HEX: '#008000'},{Name: 'greenyellow', HEX: '#adff2f'},{Name: 'grey', HEX: '#808080'},{Name: 'honeydew', HEX: '#f0fff0'},{Name: 'hotpink', HEX: '#ff69b4'},{Name: 'indianred', HEX: '#cd5c5c'},{Name: 'indigo', HEX: '#4b0082'},{Name: 'ivory', HEX: '#fffff0'},{Name: 'khaki', HEX: '#f0e68c'},{Name: 'lavender', HEX: '#e6e6fa'},{Name: 'lavenderblush', HEX: '#fff0f5'},{Name: 'lawngreen', HEX: '#7cfc00'},{Name: 'lemonchiffon', HEX: '#fffacd'},{Name: 'lightblue', HEX: '#add8e6'},{Name: 'lightcoral', HEX: '#f08080'},{Name: 'lightcyan', HEX: '#e0ffff'},{Name: 'lightgoldenrodyellow', HEX: '#fafad2'},{Name: 'lightgray', HEX: '#d3d3d3'},{Name: 'lightgreen', HEX: '#90ee90'},{Name: 'lightgrey', HEX: '#d3d3d3'},{Name: 'lightpink', HEX: '#ffb6c1'},{Name: 'lightsalmon', HEX: '#ffa07a'},{Name: 'lightseagreen', HEX: '#20b2aa'},{Name: 'lightskyblue', HEX: '#87cefa'},{Name: 'lightslategray', HEX: '#778899'},{Name: 'lightslategrey', HEX: '#778899'},{Name: 'lightsteelblue', HEX: '#b0c4de'},{Name: 'lightyellow', HEX: '#ffffe0'},{Name: 'lime', HEX: '#00ff00'},{Name: 'limegreen', HEX: '#32cd32'},{Name: 'linen', HEX: '#faf0e6'},{Name: 'magenta', HEX: '#ff00ff'},{Name: 'maroon', HEX: '#800000'},{Name: 'mediumaquamarine', HEX: '#66cdaa'},{Name: 'mediumblue', HEX: '#0000cd'},{Name: 'mediumorchid', HEX: '#ba55d3'},{Name: 'mediumpurple', HEX: '#9370db'},{Name: 'mediumseagreen', HEX: '#3cb371'},{Name: 'mediumslateblue', HEX: '#7b68ee'},{Name: 'mediumspringgreen', HEX: '#00fa9a'},{Name: 'mediumturquoise', HEX: '#48d1cc'},{Name: 'mediumvioletred', HEX: '#c71585'},{Name: 'midnightblue', HEX: '#191970'},{Name: 'mintcream', HEX: '#f5fffa'},{Name: 'mistyrose', HEX: '#ffe4e1'},{Name: 'moccasin', HEX: '#ffe4b5'},{Name: 'navajowhite', HEX: '#ffdead'},{Name: 'navy', HEX: '#000080'},{Name: 'oldlace', HEX: '#fdf5e6'},{Name: 'olive', HEX: '#808000'},{Name: 'olivedrab', HEX: '#6b8e23'},{Name: 'orange', HEX: '#ffa500'},{Name: 'orangered', HEX: '#ff4500'},{Name: 'orchid', HEX: '#da70d6'},{Name: 'palegoldenrod', HEX: '#eee8aa'},{Name: 'palegreen', HEX: '#98fb98'},{Name: 'paleturquoise', HEX: '#afeeee'},{Name: 'palevioletred', HEX: '#db7093'},{Name: 'papayawhip', HEX: '#ffefd5'},{Name: 'peachpuff', HEX: '#ffdab9'},{Name: 'peru', HEX: '#cd853f'},{Name: 'pink', HEX: '#ffc0cb'},{Name: 'plum', HEX: '#dda0dd'},{Name: 'powderblue', HEX: '#b0e0e6'},{Name: 'purple', HEX: '#800080'},{Name: 'red', HEX: '#ff0000'},{Name: 'rosybrown', HEX: '#bc8f8f'},{Name: 'royalblue', HEX: '#4169e1'},{Name: 'saddlebrown', HEX: '#8b4513'},{Name: 'salmon', HEX: '#fa8072'},{Name: 'sandybrown', HEX: '#f4a460'},{Name: 'seagreen', HEX: '#2e8b57'},{Name: 'seashell', HEX: '#fff5ee'},{Name: 'sienna', HEX: '#a0522d'},{Name: 'silver', HEX: '#c0c0c0'},{Name: 'skyblue', HEX: '#87ceeb'},{Name: 'slateblue', HEX: '#6a5acd'},{Name: 'slategray', HEX: '#708090'},{Name: 'slategrey', HEX: '#708090'},{Name: 'snow', HEX: '#fffafa'},{Name: 'springgreen', HEX: '#00ff7f'},{Name: 'steelblue', HEX: '#4682b4'},{Name: 'tan', HEX: '#d2b48c'},{Name: 'teal', HEX: '#008080'},{Name: 'thistle', HEX: '#d8bfd8'},{Name: 'tomato', HEX: '#ff6347'},{Name: 'turquoise', HEX: '#40e0d0'},{Name: 'violet', HEX: '#ee82ee'},{Name: 'wheat', HEX: '#f5deb3'},{Name: 'white', HEX: '#ffffff'},{Name: 'whitesmoke', HEX: '#f5f5f5'},{Name: 'yellow', HEX: '#ffff00'},{Name: 'yellowgreen', HEX: '#9acd32'},
],
        TopItems: [ { title: 'Main', icon: 'mdi-subdirectory-arrow-left',Menu: false,Route: 'SystemConfig/'+process.env.VUE_APP_RA_SYSTEM_ID},],
        sitenavitems: [
            {title: 'Site Info', icon: 'mdi-information',Menu: false},
        { title: 'Add Content', icon: 'mdi-plus',Menu: false},
          { title: 'Site Menu & Pages', icon: 'mdi-home-city',Menu: false}, 
          { title: 'App Styling', icon: 'mdi-palette-advanced' ,Menu: false},
          { title: 'Page Design', icon: 'mdi-palette' ,Menu: false},
          { title: 'Page Layout', icon: 'mdi-monitor-dashboard' ,Menu: false}, 
          { title: 'Media', icon: 'mdi-folder-image' ,Menu: false},  
          { title: 'Plugins', icon: 'mdi-apps' ,Menu: false},       
           { title: 'FAQ', icon: 'mdi-account-question' ,Menu: false, Route: 'FAQAdmin',ORPlugins: ['FAQ'],
            PreDialog: true,
            IMG: require('@/assets/logo.png'),
            Writeup: `<p>Create and maintain a list of Frequently Asked Questions to add to your Website Pages</p>`
            },
            { title: 'Chatbot', icon: 'mdi-robot',Route: 'ChatbotBuilder' ,ORPlugins: ['Chatbot'],
            PreDialog: true,
            IMG: require('@/assets/logo.png'),
            Writeup: `<p>Capitalize on FAQ and configure chatbot for responses. Further expand the chatbot with "virtual assist" responses such as "How many Orders were placed last week".</p>`,},
             { title: 'Web Forms', icon: 'mdi-form-select' ,Menu: false, Route: 'WebForms',ORPlugins: ['Web_Forms'],
            PreDialog: true,
            IMG: require('@/assets/logo.png'),
            Writeup: `<p>Create Web Forms to embed on your Website Pages. Web Forms become backend data records managed through a leads management system. Add any fields you need. All Forms completed by signed in Users capture the user information.</p>`
            },
        ],
        
        }
    },
    computed:{
        PDFDataRecord(){
        return this.$store.state.PDFDataRecord
        },
        SiteSubscriptionPackages(){
            return this.SubscriptionPackages.filter(pack => {
                return pack.Type && pack.Type.Name === 'Sites Directory'
            })
        },
        AvailableSiteSubscriptionPackages(){
            return this.SiteSubscriptionPackages.filter(pack => {
                return this.System.Site_Category && pack.CategoryFilter && pack.CategoryFilter.ID === this.System.Site_Category.ID
            })
        },
        SitePackageField(){
            //console.log(this.NewGroupFeatures,this.NewGroupPaidFeatures,this.NewGroupScope,this.NewGroupPaidScope)
            let fieldobj = {id: 'Subscription_Package',Name: 'Subscription_Package',DisplayName: 'Subscription Package',value: 'Subscription_Package',text: 'Subscription Package',
            Type: 'Lookup',LookupFieldName: 'Name',Array: this.AvailableSiteSubscriptionPackages, Response: '',IsMandatory: true,
            LookupSubtitleField: {Name: 'Price',Type: 'Number Field',IsCurrency: true},
            LookupCaptionField: {Name: 'Description'},
            LookupAvatarField: {Name: 'IMG'},DialClass: 'whiteoverlay',
            Has_Selection_Dial: true,CardFlat: true,CardDark: false,DialType: 'Lookup Cards',CardWidth: '100vw',CardHeight: '100vh',CardClass: 'transparent',DialHeader: 'Select a Subscription Package',DialCaption: 'The packages available for your selections are:'}
            return fieldobj
        },
        SitesDirectory(){
            return this.Directories.find(obj => obj.id === 'Systems')
        },
        SitesCategoryField(){
            return this.SitesDirectory && this.SitesDirectory.ListPrimaryField ? this.SitesDirectory.ListPrimaryField : ''
        },
        SiteCategories(){
            let field = this.SitesDirectory.ListPrimaryField
            return field && field.Options ? 
            field.Options : []
        },
        SiteKeyWordOptions(){
            return this.$store.state.SiteKeyWordOptions.filter(kw => {
                return kw.Type.Name === 'Site'
            })
        },
        ComputedWebsiteProgressChecker(){
            let obj = this.WebsiteProgressChecker
            obj.StepRequirements = obj.StepRequirements.map(step => {
                if(step.Prop.ChildProps){
                    step.Prop.ChildProps = step.Prop.ChildProps.map(prop => {
                        if(prop.Name === 'Public_Landing_Page'){
                            prop.Options = this.SitePages.filter(page => {
                                return page.PublishType === 'Public'
                            })
                            .map(page => {
                                return '/'+page.id
                            })
                        }
                        else if(prop.Name === 'KeyWords'){
                            prop.Options = this.SiteKeyWordOptions
                        }
                        else if(prop.Name === 'Site_Category'){
                            prop = this.SitesCategoryField
                        }
                        else if(prop.Name === 'Subscription_Package'){
                            prop = this.SitePackageField
                        }
                        
                        return prop
                    })
                }
                return step
            })
            obj.System = this.System
            obj.System.Pages = this.SitePages
            
            let colprops = ['PublicNavbarText','PublicNavbarSelectedText','PublicNavbarItemSelectBG','PublicNavbarItemHoverBG']
            colprops.map(prp => {
                if(!obj.System[prp]){
                obj.System[prp] = '#000000'
                }
            })
            // obj.Pages = this.SitePages
            // obj.Email = this.System.Email
            // obj.Telephone_Number = this.System.Telephone_Number
            // obj.Description = this.System.Description
            // obj.KeyWords = this.System.KeyWords
            // obj.Public_Landing_Page = this.System.Public_Landing_Page
            // obj.Logo = this.System.Logo
            //console.log('osbj',obj,this.$store.state.SiteKeyWordOptions)
            return obj
        },
        DataViewTabs(){
            //console.log('this.RenderedContentBlocks',this.RenderedContentBlocks)
            let tabs = this.RenderedContentBlocks.filter(tab => {
                return tab.DataViewName
            })
            //console.log('tabs',tabs)
            return tabs
        },
        StorePagePresets(){
            return this.$store.state.StorePagePresets
        },
        ComputedFontOptions(){
            return this.FontOptions.concat(this.System.CustomFonts.map(font => {return font.Name}))
        },
        CSSColorswithChildren(){
            let length = this.CSSColors.length
            let max = 3
            let sectionlength = Math.ceil(length/max)
            let sections = []
            let firstindex = 0
            let finalindex = max
            //console.log(length,sectionlength,this.CSSColors)
            for(var x = 0; x < sectionlength;x++){
                //console.log(firstindex,finalindex)
                let newchildren = this.CSSColors.slice(firstindex,finalindex)
                //console.log(newchildren)
                let newsect = {Children: newchildren}
                sections.push(newsect)
                firstindex = firstindex+max
                finalindex = finalindex+max
            }
            return sections
        },
        SystemisRA(){
      return process.env.VUE_APP_RA_SYSTEM_ID === process.env.VUE_APP_RA_PROVIDER_ID
    },
        RAStorePagePresets(){
            return this.$store.state.RAStorePagePresets
        },
        ContentBlocks(){
            return this.$store.state.ContentBlocks
        },
        RAAdmin(){
        return this.RAUserObj && this.RAUserObj.rolesarrayDBRules && this.RAUserObj.rolesarrayDBRules.SystemAdmin
    },
    RAUserObj(){
        return this.$store.state.RAUserObj
    },
        ActiveSuiteApp(){
            return this.$store.state.ActiveSuiteApp
        },
        AppEntities(){
            return this.SystemEntities.filter(ent => {
                return ent.Primary_Appid === this.ActiveSuiteApp.id
            })
        },
       AppandSharedPlugins(){
            return this.AppPlugins.concat(
              this.ActiveSuiteApp.SharedPlugins .map(plug => {
                let plugobj = this.RAPlugins.find(obj => obj.id === plug.id)
                if(!plugobj){
                    plugobj = plug
                }
                return plugobj
            }).filter(plug => {
                return plug.Name
            }) 
            )
        },
        AppPlugins(){
            return this.ActiveSuiteApp.Plugins.map(plug => {
                let plugobj = this.RAPlugins.find(obj => obj.id === plug.id)
                if(!plugobj){
                    plugobj = plug
                }
                return plugobj
            }).filter(plug => {
                return plug.Name
            })
        },
        DataSingleBuilder(){
            return this.$route.meta && this.$route.meta.DataSingleBuilder || this.$route.name === 'SuiteApp' && this.CurrentEntity
        },
        CurrentEntity(){
            return this.$store.state.CurrentEntity
        },
        PreviewedContentblocks(){
        return this.RAStorePagePresets.filter(item => {
                //console.log(item,this.ActiveBlockClass)
                return this.ActiveBlockClass ? item.Category === this.ActiveBlockClass : item
                //return item
            })
        },
        ComputedRenderedContentBlocks(){
            return this.RenderedContentBlocks.filter(item => {
                if(this.DataSingleBuilder && item.DataViewName === 'Data Single Standard'){
                    return item
                }
                else if(this.DataSingleBuilder && item.DataViewName === 'Data Single Cabinet'){
                    return this.AppPlugins.find(obj => obj.id === 'Cabinets')
                }
                else if(this.DataSingleBuilder){
                    return item.DataViewName === 'Data Single Related'      
                }
                
                else{
                    return item
                }
            })
            .filter(item => {
                //console.log(item,this.ActiveBlockClass)
                return this.ActiveBlockClass ? item.Category === this.ActiveBlockClass : item
                //return item
            })
        },
        PluginDataBase(){
            return this.$store.state.PluginDataBase
        },
        ComputedBuilders(){
            return this.Builders.filter(builder => {
            return this.PluginDataBase[builder.Name.split(' ').join('_')] && this.PluginDataBase[builder.Name.split(' ').join('_')].Active
            })
        },
        WebsiteisActive(){
            return this.$store.state.WebsiteisActive
        },
        SocialNetworkisActive(){
            return this.$store.state.SocialNetworkisActive
        },
        DatabaseisActive(){
            return this.$store.state.DatabaseisActive
        },
        DocumentationisActive(){
            return this.$store.state.DocumentationisActive
        },
        MainDialRight(){
            return this.SelectedMain && this.SelectedMain.title === 'App Styling'
            || this.SelectedMain && this.SelectedMain.title === 'Plugins'
        },
        MainDialStyling(){
            if(this.SelectedMain && this.SelectedMain.title === 'App Styling'){
                return 'position: fixed;top:125px;z-index:6;height:80%;'
            }
            else if(this.SelectedMain && this.SelectedMain.title === 'Plugins' && !this.DataSingleBuilder){
                if(this.$vuetify.breakpoint.xs){
                    return 'z-index: 6;width:300px;top:125px;padding-bottom:50px;'
                }
                else if(this.$vuetify.breakpoint.sm){
                    return 'z-index: 6;width:600px;top:125px;padding-bottom:50px;'
                }
                else{
                    return 'z-index: 6;width:65%;top:125px;padding-bottom:50px;'
                }
            }
             else if(this.SelectedMain && this.SelectedMain.title === 'Plugins' && this.DataSingleBuilder){
                if(this.$vuetify.breakpoint.xs){
                    return 'z-index: 6;width:300px;top:60px;padding-bottom:50px;'
                }
                else if(this.$vuetify.breakpoint.sm){
                    return 'z-index: 6;width:600px;top:60px;padding-bottom:50px;'
                }
                else{
                    return 'z-index: 6;width:65%;top:60px;padding-bottom:50px;'
                }
            }
            else if(this.SelectedMain && this.SelectedMain.title === 'Add Content'){
                return this.DataSingleBuilder || this.$route.name === 'SystemConfig'? 'position: fixed;left: 88px;top:65px;z-index:6;height:60%;'
             : 'position: fixed;top:50px;z-index:6;height:100%;left: -1000px;'
            }
            else{
                return this.DataSingleBuilder || this.$route.name === 'SystemConfig'? 'position: fixed;left: 88px;top:65px;z-index:6;height:60%;'
             : 'position: fixed;left: 88px;top:190px;z-index:6;height:60%;'
            }
        },
        AdvancedComputedLibraryColors(){
      let arr1 = this.LibraryColors
      let arr2 = [
        'primary',
        'accent',
        'secondary',
        'pop',
        'morning',
        'night',
        'fieldcard',
        'links',
        'background',
      ]
      let arr3 = arr1.concat(arr2)
      let arr4 = []
      arr3.map(color => {
        arr4.push(color)
        arr4.push(color+' lighten-1')
        arr4.push(color+' lighten-2')
        arr4.push(color+' lighten-3')
        arr4.push(color+' lighten-4')
        arr4.push(color+' lighten-5')
        arr4.push(color+' darken-1')
        arr4.push(color+' darken-2')
        arr4.push(color+' darken-3')
        arr4.push(color+' darken-4')
        arr4.push(color+' darken-5')
        arr4.push(color+' accent-1')
        arr4.push(color+' accent-2')
        arr4.push(color+' accent-3')
        arr4.push(color+' accent-4')
      })
      return arr4
    },
        ActiveAppStylingNavbar(){
     if(this.$route.name === 'MyAccount'){
       return 'Guest Navbar'
     }
     else if(this.DBBuilderView){
        return 'DB Navbar'
      }
      else if(this.WebsiteBuilderView){
        if(this.$route.meta && this.DataSingleBuilder && this.$route.name !== 'SystemConfig'){
          return 'DB Navbar'
        }
        else{
          return 'Public Navbar'
        }
      }
      else if(this.NetworkBuilderView){
        return 'Social Navbar'
      }
   },
        GroupidRoutes(){
            return this.$store.state.GroupidRoutes
        },
        GroupslugRoutes(){
            return this.$store.state.GroupslugRoutes
        },
        GroupID(){
            if(this.GroupidRoutes.includes(this.$route.name)){
                return this.$route.params.id
            }
            else if(this.$route.query && this.$route.query.GroupID){
                return this.$route.query.GroupID
            }
            else if(this.GroupslugRoutes.includes(this.$route.name)){
                return this.$route.params.slug
            }
        },
        WebForms(){
            if(this.IsGroupView){
                return this.GroupEntities.filter(ent => {
                    return ent.Entity_Type && ent.Entity_Type.Name === 'Web Form' && ent.groupid === this.GroupID
                })
            }
            else{
                return this.WebFormEntities
            }
        },
        IsGroupView(){
        return this.$store.state.IsGroupView
    },
        draggingtab(){
            return this.$store.state.draggingtab
        },
        draggingtabindex(){
            return this.$store.state.draggingtabindex
        },
        draggingelement(){
            return this.$store.state.draggingelement
        },
        draggingelementindex(){
            return this.$store.state.draggingelementindex
        },
        draggingrow(){
            return this.$store.state.draggingrow
        },
        draggingrowindex(){
            return this.$store.state.draggingrowindex
        },
        dragging(){
            return this.$store.state.dragging
        },
        NavbarItems(){
            if(this.IsGroupView){
                return [{Name: 'Group',Prop: 'GroupNavbarItems',PublishType: ''}]
            }
            else{
                return [{Name: 'Public',Prop: 'PublicNavbarItems',PublishType: 'Public'},{Name: 'Social',Prop: 'SocialNavbarItems',PublishType: 'Members Only'}]
            }
        },
        PageTabsPropName(){
            if(this.$route.meta && this.DataSingleBuilder || this.$route.meta && this.$route.meta.SubColEntryViewer){
                return 'SingleBuildTabs'
            }   
            else if(this.$route.meta && this.$route.meta.ClassifiedListingBuilder){
                return 'ClassifiedTabs'
            }
            else if(this.$route.meta && this.$route.meta.WikiListingBuilder){
                return 'WikiTabs'
            }
            else{
                return 'PageTabs'
            }
        //return this.$route.meta && this.DataSingleBuilder || this.$route.meta && this.$route.meta.SubColEntryViewer? 'SingleBuildTabs' : 'PageTabs'
    },		
        PageTabs(){
            console.log('EditedPage',this.EditedPage)
            return this.EditedPage ? this.EditedPage[this.PageTabsPropName] : []
        },
        EditedPage(){
            return this.$store.state.EditedPage
        },
        RenderedContentBlocks(){
            return this.$store.state.RenderedContentBlocks
        },
        BuilderView(){
        return this.$store.state.BuilderView
        },
        WebsiteBuilderView(){
            return this.BuilderView && this.BuilderView.Name === 'Website Builder'
        },
        DBBuilderView(){
            return this.BuilderView && this.BuilderView.Name === 'Database Builder'
        },
        NetworkBuilderView(){
            return this.BuilderView && this.BuilderView.Name === 'Social Network Builder'
        },
        SystemAssets(){
            return this.$store.state.SystemAssets
        },
        MiniView(){
            return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
        },
        SiteDialog(){
            return this.$store.state.SiteDialog
        },
        SelectedImage(){
        return this.$store.state.SelectedGalleryAsset
      },
      FilteredTopItems(){
            return this.TopItems.filter(item => {
                if(!this.IsGroupView || this.IsGroupView && this.$route.name === 'GroupEdit'){
                    return item.title !== 'Main'
                }
                else{
                    return item
                }
            }).map(item => {
                if(this.IsGroupView && item.title === 'Main'){
                   item.Route = 'Group/Edit/'+this.GroupID  
                }
                return item
            })
      },
        Computedsitenavitems(){
            return this.sitenavitems.filter(item => {
                if(this.DataSingleBuilder && this.$route.name !== 'SystemConfig'){
                    return item.title === 'Add Content' || item.title === 'Page Layout' || item.title === 'App Styling' || item.title === 'Plugins'
                }
                else if(this.$route.name === 'SystemConfig'){
                    return item.title === 'Site Menu & Pages' || item.title === 'Media'
                }
                else if(this.$route.name === 'newlandingpage'){
                    
                    return item.title !== 'Site Menu & Pages'
                }
                else if(this.IsGroupView && this.$route.name !== 'GroupPageEditor'){                    
                    return item.title !== 'Add Content' && item.title !== 'Chatbot'
                    && item.title !== 'FAQ' && item.title !== 'Page Design' && item.title !== 'Page Layout'
                    //later we will add FAQ back in to groups for sure
                }
                else if(this.IsGroupView){                    
                    return item.title !== 'Chatbot'
                    && item.title !== 'FAQ'
                    //later we will add FAQ back in to groups for sure
                }
                else{
                    return item
                }
            }).filter(item => {
                if(item.ORPlugins){
                    let pass = false
                    item.ORPlugins.map(plug => {
                        if(this.PluginDataBase[plug] && this.PluginDataBase[plug].Active){
                            pass = true
                        }
                    })
                    return pass
                }
                else if(item.ANDPlugins){
                    let pass = true
                    return pass
                }
                else{
                    return item
                }
            })
        },
        ComputedNavbarPages(){
            return this.NavbarPages.map(page => {
                page.OnMenu = false
                let oncheck = this.ComputedNavList.find(obj => obj.Path === page.PageRoute)
                if(oncheck){
                    page.MenuIndex = oncheck.MenuIndex
                    page.OnMenu = true
                    if(oncheck.Children){
                        page.Children = oncheck.Children
                    }
                    if(typeof oncheck.MenuOnly !== 'undefined'){
                        page.MenuOnly = oncheck.MenuOnly
                    }
                }
                else{
                    page.OnMenu = false
                    page.MenuIndex = 100000
                }
                return page
            })
            .map(page => {
                if(page.OnMenu){
                    page.RenderStyling = 'links--text'
                }
                else{
                    page.RenderStyling = 'grey--text'
                }
                return page
            })
            .sort((a, b) => {
                var key1 = a.MenuIndex;
                var key2 = b.MenuIndex;

                if (key1 < key2) {
                    return -1;
                } else if (key1 == key2) {
                    return 0;
                } else {
                    return 1;
                }
        })
        },
        
        ActiveGroup(){
            return this.$store.state.ActiveGroup
        },
        ComputedSitePages(){
            if(this.IsGroupView){
                console.log(this.ActiveGroup)
                return this.ActiveGroup && this.ActiveGroup.Pages ? this.ActiveGroup.Pages : []
            }
            else{
                return this.SitePages
            }
        },
        NavListArray(){
            return this[this.NavlistHolder] && this.SelectedNavbar && this[this.NavlistHolder][this.SelectedNavbar.Prop] ? this[this.NavlistHolder][this.SelectedNavbar.Prop]
            : []
        },
        NavlistRef(){
            return this.NavlistHolder === 'ActiveGroup' && this.ActiveGroup ? db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.ActiveGroup.id) : 
            db.collection('Websites').doc(this.$store.state.ActiveSuiteid)
        },
        NavlistHolder(){
            if(this.IsGroupView){
                return 'ActiveGroup'
            }
            else{
                return 'System'
            }
        },
        ComputedNavList(){
            let arr = this.NavListArray
            //console.log(arr)
            return arr.map((item,arrindex) => {
                item.MenuIndex = arrindex
                return item
            })
        },
        NavbarPages(){
            if(this.IsGroupView){
                return this.ComputedSitePages
            }
            else{
             return this.ComputedSitePages.filter(page => {
                     return page.PublishType === 'Public'
            })   
            }            
        },
        DefaultPath(){
            //UpdateSEOBasics
            if(this.$route.name === 'PageEditor'){
                return this.System.ClientAppURL+'/'
            }
            else if(this.IsGroupView){
                return this.System.ClientAppURL+'/Group-Page/'+this.GroupID+'/'
            }
        },
        userLoggedIn () {
        return this.$store.getters.user
        },
        userIsAdmin () {
            return this.$store.state.IsAdmin
        },
        WindowHeight(){
            return window.innerHeight
        },
        SocialItemInteractMethod(){
        return this.$store.state.SocialItemInteractMethod
        },
        SocialItemInteractMethodProp(){
            return this.$store.state.SocialItemInteractMethodProp
        },
        SelectedImage(){
        return this.$store.state.SelectedGalleryAsset
      },
      UnPaidPlugins(){
          return this.RAPlugins.filter(plug => {
              return this.PluginDataBase[plug.id] && !this.PluginDataBase[plug.id].Active
          })
      },
      PurchasablePlugins(){
          return this.RAPlugins.filter(plug => {
            //console.log('this.PluginDataBase',this.PluginDataBase)
              return !this.PluginDataBase[plug.id] && plug.Strictly_One_Purchase || !plug.Strictly_One_Purchase
          })
      },
      RAPlugins(){
          return this.$store.state.RAPlugins
        },
        ActiveMarketTemplate(){
            return this.$store.state.ActiveMarketTemplate
          },
        MarketDialogType(){
            return this.$store.state.MarketDialogType
        },
        SiteAccount(){
            return this.$store.state.PrimaryUserObj && this.$store.state.PrimaryUserObj.BillingAccounts ? 
            this.$store.state.PrimaryUserObj.BillingAccounts.find(obj => obj.id === this.$store.state.ActiveSuiteid) : 
            ''
        },
    },
    watch: {
        EditedPage : {
            handler: function(newvalue, oldvalue) {
                if(newvalue !== oldvalue && !oldvalue){
                    this.PrepNavbar(newvalue)
                    
                }
            },deep: true
        },
        SelectedMainDialog (value){
            if(!value && this.SelectedMain){
                this.SelectedMain = ''
                if(this.ActiveBlockClass){
                    this.ActiveBlockClass = ''
                }
            }
        },
        SelectedMain (value){
            if(value){
                this.SelectedMainDialog = true
                setTimeout(() => {
                 let elmnt = document.getElementById('selectedmaindial')
                 if(elmnt && this.MiniView && elmnt.style){
                    elmnt.style.animation = 'slidefromlftmini 0.7s forwards'
                 }
                 else if(elmnt && elmnt.style){
                    elmnt.style.animation = 'slidefromlft 0.7s forwards'
                 }  
                }, 100);
                
            }
            else{
                this.SelectedMainDialog = false
            }
        },
        SocialItemInteractMethod(v){   
            //AssignImageandCloseTab method belongs here but works for group navbarimg, but then fails to put images on pagebuilder in "IMGConfigComp"
            //temporarily removed need work around change of methods
        let acceptedmethods = ['PrepareSelectedMain','AssignSiteLogo','SelectPackage','ProcessSiteSubscriptionInvoice']   
        if(v && acceptedmethods.includes(v)){
          if(this.SocialItemInteractMethodProp){
            this[this.SocialItemInteractMethod](this.SocialItemInteractMethodProp)
            if(this.SocialItemInteractMethod === 'ActivateSelectedElement'){
              this.SingleRecordNavMenuItem = ''
            }
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }
          else{ 
            this[this.SocialItemInteractMethod]()
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }          
        }
      },
    },
    created(){
        if(!this.System.Business_Hours){
            this.System.Business_Hours = {
                WeekDays: {},
                WeekEnds: {},
                PublicHolidays: {}
            }
        }
        //console.log(this.System.Business_Hours)
        this.PrepareAddressField('Company_Address',this.System)
        this.PrepareAddressField('Billing_Address',this.System)
        //console.log(this.RAStorePagePresets)
        if(this.RAStorePagePresets.length === 0){
            let presetquery = ''
            if(!this.SystemisRA && this.RADB && this.RAUserObj){
                presetquery = this.RADB.collection('pagepresets')
            }
            else if(this.SystemisRA){
                presetquery = db.collection('pagepresets')
            }
            if(presetquery){
              let presetpayload = {                
                query: presetquery,
                arrayname: 'RAStorePagePresets'
                }
                this.$store.dispatch('GetCollectionArray',presetpayload).then(function(result) {    
                    //console.log(vm.$store.state.RAPluginPackages)
                    })  
            }
            
        }
        if(this.StorePagePresets.length === 0){
            let presetquery = db.collection('storedpagepresets')
            let presetpayload = {                
                query: presetquery,
                arrayname: 'StorePagePresets'
                }
                this.$store.dispatch('GetCollectionArray',presetpayload).then(function(result) {    
                    //console.log(vm.$store.state.RAPluginPackages)
                    })
        }
        
        //console.log(this.$route.name,this.IsGroupView)
        if(this.EditedPage){
            this.PrepNavbar(this.EditedPage)
            let queryobj = this.$route.query
            if(!queryobj || this.$route.name === 'PageBuilder' || queryobj && Object.keys(queryobj).length === 0 && queryobj.constructor === Object){
            this.GetGalleryObjects()    
            }
        }
        else if(this.$route.name === 'PageEditor'){
            this.PublishType = 'Public'
            this.PrepNavbar()
        }
        else if(this.$route.name === 'SystemConfig'){
            this.PublishType = 'Public'
            this.SelectedNavbar = this.NavbarItems.find(obj => obj.Name === 'Public')
        }
        else if(this.DataSingleBuilder){
         
        }
        else if(this.IsGroupView){
                this.SelectedNavbar = this.NavbarItems.find(obj => obj.Name === 'Group')
            }
            else {
                let page = ''
                if(this.System.Public_Landing_Page){
                    page = this.SitePages.find(obj => obj.Name == this.System.Public_Landing_Page)
                }
                else if(this.WebsiteBuilderView){
                    page = this.SitePages.find(obj => obj.PublishType === 'Public')
                }
                else if(this.NetworkBuilderView){
                    page = this.SitePages.find(obj => obj.PublishType === 'Members Only')
                }
                if(page){
                    //console.log(page)
                    this.$emit('SelectPage',page)
                }
            }
        
    },
    methods:{
        TogglePageMenuOnly(page){
            page.MenuOnly = !page.MenuOnly
            let item = this[this.NavlistHolder][this.SelectedNavbar.Prop].find(obj => obj.title === page.Name)
            if(item){
                if(typeof item.MenuOnly === 'undefined'){
                    item.MenuOnly = false
                }
                item.MenuOnly = !item.MenuOnly
            }
            this.SelectedMainDialog = false
            setTimeout(() => {
                    this.SelectedMainDialog = true
            }, 10);
        },
        PushPageUpwards(page,pageindex){
            let parentindex = pageindex-1
            console.log(page.MenuIndex,parentindex)
            //MOYO IMPORTANTE!!!! WHEN MANIPULATING WE SHOULD INF ACT MANIPULATE COMPUTEDNAVLIST, BECAUSE COMPUTEDNAVBARPAGES REFER TO IT
            //Here by example, we first used Navbarpages to obtain parent page. when you splice the children array it removes but immediatley pushes back in due to computednavlist obj still having it as a child
            let parentpage = this.ComputedNavList.find(obj => obj.id === page.Parentid)            
            let childindex = page.MenuIndex.split('.')[1]
            childindex = Number(childindex)-1
            //console.log(parentpage.Children.length)
            parentpage.Children.splice(childindex,1)
            // console.log(parentpage.Children.length)
            // console.log(parentpage,childindex)
            let pageobj = this.NavbarPages.find(obj => obj.id === page.id)
            pageobj.SubPage = false
            page.SubPage = false
            let navpage = {
                id: page.id,
                Path: page.PageRoute,
                title: page.Name,
                MenuIndex: parentindex-1+2,
            }   
            if(page.PageIcon){
                navpage.icon = page.PageIcon
            }
            if(parentpage.OnMenu){
                navpage.OnMenu = parentpage.OnMenu
            }
            this[this.NavlistHolder][this.SelectedNavbar.Prop].splice(parentindex-1+2,0,navpage)
            
            this[this.NavlistHolder][this.SelectedNavbar.Prop].map((item,itemindex) => {
                item.MenuIndex = itemindex
                if(item.Children){
                    item.Children.map((child,childindex) => {
                    let parentnext = childindex-1+2
                    let newindex = item.MenuIndex+'.'+parentnext
                    child.MenuIndex = newindex
                })
                }
                
            })
            console.log(this[this.NavlistHolder][this.SelectedNavbar.Prop])
            //this.RefreshTitleDialog()
        },
        PushtoPreviousNavItem(page,pageindex){
            let fromaddpage = false
            let parentindex = pageindex-1
            // if(parentindex !== -1){
            //     fromaddpage = true
            //     parentindex = this.NavParentIndex
            //     this.NavParentIndex = -1
            // }
            // else{
            //     parentindex = page.MenuIndex-1
            // }
            console.log(fromaddpage,parentindex)
            let parentpage = this[this.NavlistHolder][this.SelectedNavbar.Prop][parentindex]
            if(!parentpage.Children){
                parentpage.Children = []
            }
            let parentnext = parentpage.Children.length-1+2
            let newindex = parentindex+'.'+parentnext
           //console.log(newindex,typeof newindex,parentpage)
            let navpage = {
                id: page.id,
                Path: page.PageRoute,
                title: page.Name,
                MenuIndex: newindex,
                ParentIndex: parentindex,
                Parentid: parentpage.id
            }   
            if(page.PageIcon){
                navpage.icon = page.PageIcon
            }
            console.log(page,parentpage,navpage,newindex)     
            if(!fromaddpage){
              this[this.NavlistHolder][this.SelectedNavbar.Prop].splice(page.MenuIndex,1)  
            }            
            parentpage.Children.push(navpage)
            page.SubPage = true
           this.RefreshTitleDialog()
        },
        onPhotoUpload(payload) {
          let filename = payload.filename
          let file = payload.file
          let field = payload.field
          let storepath = 'Websites/'+this.$store.state.ActiveSuiteid+'/'+field.id+'/'+file.name+'/'+new Date()
        let vm = this
        var storageRef = firebase.storage().ref(storepath)
        var uploadTask = storageRef.put(file)
        vm.$store.commit('SetSocialItemInteractMethodProp',true) 
        vm.$store.commit('SetSocialItemInteractMethod','ActivateProcessing')
         vm.PrepareThumbnail(filename,file,storepath).then(thumbresult => {
        uploadTask
        .then(snapshot => snapshot.ref.getDownloadURL())
          .then((url) => {
            let UploadObject = {
              fileurl: url,
              url: url,
              ThumbURL: thumbresult,
              FileType: file.type,
              Modified_By: {Full_Name: vm.userLoggedIn.Full_Name,id: vm.userLoggedIn.id},
              Modified_Byid: vm.userLoggedIn.id,
              Modified_On: new Date(),
              ModifiedDate: new Date(file.lastModified),
              Size: file.size,
              StorageRef: storepath,
              filename: filename
            }
            if(field.Name === 'Logo'){
                db.collection('Websites').doc(vm.$store.state.ActiveSuiteid).update({
                    Logo: url,
                    LogoObject: UploadObject
                })
            }
            
              
                vm.$store.commit('SetSocialItemInteractMethodProp',false) 
                vm.$store.commit('SetSocialItemInteractMethod','ActivateProcessing')
             let snackbarcontent = {
              snackbartimeout: 4000,
              snackbartext: 'Added '+field.DisplayName+' to Record',
              snackbartop: true,
            }
            vm.$emit('ActivateSnackbar',true,snackbarcontent)
            // delete field.localURL
            // delete field.file
                })
         })
      },
      PrepareThumbnail(filename,file,storageref){
        let vm = this
        return new Promise(function(resolve, reject) {	
        file.tmpsrc = URL.createObjectURL(file)
              //this.OutboundPhotosforUpload.push(file)
              var img = document.createElement("IMG");
                img.setAttribute('width',150)
                img.setAttribute('src',file.tmpsrc)
                document.body.appendChild(img)
                let vm = this
                img.onload = function() {
                var c = document.createElement("canvas");
                var ctx = c.getContext("2d");
                var canvasRatio = img.naturalHeight / img.naturalWidth
                c.width = 400
                c.height = c.width*canvasRatio
                ctx.drawImage(img, 0, 0, c.width, c.height);
                c.toBlob(blob => {
                  let blobfile = new File([blob], filename, {
                  type: file.type,
            });
            //console.log(blobfile)
            var storageRef = firebase.storage().ref(storageref+'_thumb')
                document.body.removeChild(img)
                var uploadTask = storageRef.put(blobfile)
                uploadTask
                  .then(snapshot => snapshot.ref.getDownloadURL())
                    .then((thumburl) => {
                      //console.log(thumburl)
                      resolve(thumburl)
                    })
              })
                }
        })
      },
        onPhotoFileselected(field,file){
           field.localURL = URL.createObjectURL(file)
            field.UploadFile = file
        },
        UpdateAutoStep(val){
            this.AutoStep = val
        },
        TogglePublicNavbarEditing(){
        this.$emit('TogglePublicNavbarEditing')
    },
        CancelProgressSheet(){
             if(this.PublicNavbarEditing){
                    //this.TogglePublicNavbarEditing()
                }
        },
        ActivateProgressSheet(){
            if(typeof this.AutoStep === 'number'){
                this.step = this.AutoStep
            }
        },
        RegressStep(){
            this.step--
            if(this.step !== 4){
                 if(this.PublicNavbarEditing){
                    //this.TogglePublicNavbarEditing()
                }
            }
            else{
            }
        },
        UpdateSiteInfo(){
            if(!this.System.KeyWords){
                this.System.KeyWords = []
            }
            let updobj = {
                KeyWords: this.System.KeyWords.map(kw => {
                    let kwobj = {}
                    if(!kw.id){
                        let user = {Full_Name: this.userLoggedIn.Full_Name,id: this.userLoggedIn.id}
                        let date = new Date()
                        kwobj.Name = kw
                        kwobj.Type = {
                            ID: 1000002,
                            Name: 'Site'
                        },
                        kwobj.Created_By = user  
                        kwobj.Created_Byid = user.id
                        kwobj.Modified_By = user         
                        kwobj.Modified_Byid = user.id
                        kwobj.Created_On = date
                        kwobj.Modified_On = date
                        kwobj.Original_Recordid = this.$store.state.ActiveSuiteid
                    }
                    else{
                        kwobj = Object.assign({},kw)
                    }
                    return kwobj
                }),
            }
            let props = ['PublicNavbarDark','PublicNavbarStyle','PublicNavbarText','PublicNavbarSelectedText','PublicNavbarItemSelectBG','PublicNavbarItemHoverBG','Company_Name',
            'Published','SiteTelephoneNumber','SiteEmail','SiteSlogan','Description','Public_Landing_Page','Site_Category','Site_Class','Site_Type','GoogleMapsLocation','Business_Hours']
            props.map(prp => {
                if(typeof this.System[prp] !== 'undefined'){
                    updobj[prp] = this.System[prp]
                }
            })
            // ['PublicNavbarText','PublicNavbarSelectedText','PublicNavbarItemSelectBG','PublicNavbarItemHoverBG']
            // let colprops = [{Prop: 'PublicNavbarText',Name: '2'}]
            // ['Light_Public_Navbar_Header_BG','Light_Public_Navbar_BG','Light_Public_Navbar_Item','Light_Footer_BG']
            // ['Dark_Public_Navbar_Header_BG','Dark_Public_Navbar_BG','Dark_Public_Navbar_Item','Dark_Footer_BG']
            // if(this.System.Logo){
            //     updobj.Logo = this.System.Logo
            // }
            let unregisteredkeywords = updobj.KeyWords.filter(kw => {
                return !kw.id
            })
            //console.log('unregisteredkeywords',unregisteredkeywords)
            if(unregisteredkeywords.length > 0){
                //kw types = 1000001 site page, 1000002 grou page, 1000003 featued mem
                unregisteredkeywords.map((kw,kwindex) => {
                     let path = db.collection('Websites').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('sitekeywords')
                        let ref = path.doc()
                        let newdocid = ref.id
                    db.collection('Websites').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('sitekeywords').doc(newdocid).set(kw).then(newkwdoc => {
                        let sitekwobj = updobj.KeyWords.find(obj => obj.Name === kw.Name)
                        sitekwobj.id = newdocid
                        if(kwindex-1+2 === unregisteredkeywords.length){
                            let siteref = db.collection('Websites').doc(this.$store.state.ActiveSuiteid)
                           this.UpdateSearchandSite(updobj,db.collection('Websites').doc(this.$store.state.ActiveSuiteid)).then(upddoc => {
                                //this.CancelUpdateSiteInfo()
                            })
                        }
                    })
                })
            }
            else{
                let siteref = db.collection('Websites').doc(this.$store.state.ActiveSuiteid)
                this.UpdateSearchandSite(updobj,siteref)
                
            }
            //console.log(updobj)
            //technically now I need to do this one better I must check registry or check keywords and if no "id" it must first be registered
            //db.collection('SystemConfig').doc(this.$store.state.ActiveSuiteid).collection('featuredmembers').doc(this.$route.params.id).update(updobj)
        },
        GetSiteKeyWordsSearchQuery(KeyWords,query){
        let vm = this
        return new Promise(function(resolve, reject) {
            KeyWords.map((kw,i) => {
                let title = kw.Name
                //console.log('kw',kw,title)
                    vm.$store.dispatch('CreateSearchTitle',kw.Name).then(searchtitle => {
                    query = query.concat(searchtitle)
                    if(i-1+2 === KeyWords.length){
                        resolve(query)
                    }
                    })
                })
        })
        },
        UpdateSearchandSite(site,siteref){
            let vm = this
            let query = []
            if(site.Company_Name){
            vm.$store.dispatch('CreateSearchTitle',site.Company_Name).then(searchtitle => {
                query = searchtitle
                if(site.KeyWords && site.KeyWords.length > 0){
                vm.GetSiteKeyWordsSearchQuery(site.KeyWords,query).then(kwsearch => {
                    query = query.concat(kwsearch)
                    site.SearchQuery = query
                    siteref.update(site).then(upddoc => {
                        //this.CancelUpdateSiteInfo()
                    })
                })
                }
                else{
                    site.SearchQuery = query
                    siteref.update(site).then(upddoc => {
                        //this.CancelUpdateSiteInfo()
                    })
                }
                
            })
            }
            else if(site.KeyWords && site.KeyWords.length > 0){
            vm.GetSiteKeyWordsSearchQuery(site.KeyWords,query).then(kwsearch => {
                query = query.concat(kwsearch)
                site.SearchQuery = query
                siteref.update(site)
            })
            }
        },
        InitiatePackageSelection(){
            this.$store.commit('EmitMarketDialogOptions',this.AvailableSiteSubscriptionPackages)
            this.$store.commit('EmitMarketDialogObject',this.System)
            this.$store.commit('EmitMarketDialogOptions',this.AvailableSiteSubscriptionPackages)
            this.$store.commit('setSelectedBA',this.SiteAccount.id)
            this.$store.commit('setCanToggleBA',false)
            this.$store.commit('setUsePrimaryUserObj',true)       
            let paydialpayload = {
                bool: true,
                PaymentShowsPackages: true,
                }     
            
            this.$store.commit('EmitMarketDialogType','Site Directory Listing') 
            this.$store.commit('SetSocialItemInteractMethodProp',paydialpayload)
            this.$store.commit('SetSocialItemInteractMethod','TogglePaymentDialog')
        },
        ProcessSiteSubscriptionInvoice(NewPOObject){
            this.UpdateSiteInfo()
                this.step++  
                this.$store.commit('EmitMarketDialogType','')
                console.log('here is new invoice what now?',NewPOObject)            
            //well technically salesinvoice should take care of it all for us, nothing to do really. Except we could possibly sales LAtest invoice etc? I don't know need to see.
            //Most important though POST PAYMENT we need "Is_Site_Directory" bool. activate it yes. THEN?
            //
        },
    CheckObjectforUndefined(lvl,obj,path){
      for(var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          let newpath = path+'/'+prop
          if(typeof obj[prop] === 'undefined'){
            console.log('LVL '+lvl+' prop UNDEFINED!!! '+newpath,obj)
          }
          else{
            if(!Array.isArray(obj[prop])){
              //console.log('LVL '+lvl+' prop OK '+newpath+' as ',obj[prop])
              //repeat this function somehow
              if(typeof obj[prop] !== 'string'){
                this.CheckObjectforUndefined(lvl-1+2,obj[prop],newpath)
              }
              
            }
            else{              
              //call array undefined check
              this.CheckArrayforUndefined(lvl-1+2,obj[prop],newpath)
            }
          }
        }
      }
    },
    CheckArrayforUndefined(lvl,obj,path){
      //console.log('checkingprop '+checkingprop+' on path '+path)
      obj.map(arrayrecord => {
        for(var prop in arrayrecord) {
          if (arrayrecord.hasOwnProperty(prop)) {
            let newpath = path+'/'+prop
            if(typeof arrayrecord[prop] === 'undefined'){
              console.log('LVL '+lvl+' array prop UNDEFINED!!! '+newpath,arrayrecord)
            }
            else{
              //console.log('LVL '+lvl+' prop OK '+newpath+' as ',arrayrecord[prop])
              if(!Array.isArray(arrayrecord[prop])){
                if(typeof arrayrecord[prop] !== 'string'){
                this.CheckObjectforUndefined(lvl-1+2,arrayrecord[prop],newpath)
                }
              }
              else{
                this.CheckArrayforUndefined(lvl-1+2,arrayrecord[prop],newpath)
                //prop is array check for third prop
                // arrayrecord[prop].map(thirdrecord => {
                // })
              }
            }
          }
        }
      })
    },
        AdvanceSetupStep(){
            this.UpdateSiteInfo()
            if(this.step === 50){
                this.InitiatePackageSelection()
            }
            else{
             if(this.step === this.AutoStep || typeof this.AutoStep !== 'number'){
                //now we need to actually capture info and shit...
                //this.UpdateSiteInfo()
                this.step++
            }
            else{
                this.step++
            }
            if(this.step === 4){
                //this.TogglePublicNavbarEditing()
            }
            else{
                if(this.PublicNavbarEditing){
                    //this.TogglePublicNavbarEditing()
                }
            }   
            }
            
        },
        AssignSiteLogo(){
            //what about ?AssignImageandCloseTab
        this.System.Logo = this.SelectedImage.fileurl
        db.collection('Websites').doc(this.$store.state.ActiveSuiteid).update({
            Logo: this.System.Logo
        })
        this.$store.commit('setIMGProp','')
      },
        ActivateGalleryDialog(prp){
      if(!this.ActiveMarketTemplate){
        this.$store.commit('SetSocialItemInteractMethodProp',true)
      }
        this.$store.commit('SetSocialItemInteractMethod','ToggleGalleryDialog')
        this.$store.commit('setIMGProp',prp)
      },
        UpdatePublicLandingPage(page){
            let path = '/'+page.Name.split(' ').join('-')
            db.collection('Websites').doc(this.$store.state.ActiveSuiteid).update({
                Public_Landing_Page: path
            })
        },
        // Correct(){
        //     let item = this.RAStorePagePresets.find(obj => obj.id === 'HTML_Snipper')
        //     item.Preset_Name = 'HTML Snippet'
        //     item.id = 'HTML_Snippet'
        //     this.RADB.collection('pagepresets').doc(item.id).set(item)

        // },
        AdvanceContentBlocktoPresetDial(){
            if(this.BulkContentPresetStep === 1){
                this.BulkContentPresetStep++
            }
            else{
                this.BulkContentPresetStep = 1
                this.SaveRAPreset()
            }
        },
        CancelRAPresetDialog(BulkAdding){
            this.RAPresetDialog = false
            if(BulkAdding){
                this.BulkContentPresetStep = 1
                if(this.AddingBlocks[this.BulkContenttoPresetIndex-1+2]){
                    this.BulkContenttoPresetIndex++
                    this.RAPresetTab = Object.assign({},this.AddingBlocks[this.BulkContenttoPresetIndex-1+2])
                    this.BulkContentPresetStep++
                }
                else{                    
                    this.BulkContentBlocktoPresetDialog = false
                    this.AddingBlocks = []
                    this.RAPresetTab = Object.assign({},this.DefaultRAPresetTab)
                }
            }
            else{
            this.RAPresetTab = Object.assign({},this.DefaultRAPresetTab)
            }
        },
        SaveRAPreset(){
            let newdocid = this.RAPresetTab.Preset_Name.split(' ').join('_')
            if(this.RAPresetTab.Database === 'RA Presets'){
             this.RADB.collection('pagepresets').doc(newdocid).set(this.RAPresetTab).then(newdoc => {
                this.CancelRAPresetDialog(this.BulkContentBlocktoPresetDialog)
            })
            }
            else{
              db.collection('storedpagepresets').doc(newdocid).set(this.RAPresetTab).then(newdoc => {
                this.CancelRAPresetDialog(this.BulkContentBlocktoPresetDialog)
            })  
            }
        },
        AddRAPresetDialog(tab){
            this.RAPresetTab = JSON.parse(JSON.stringify(tab))
            if(!this.RAPresetTab.Database){
                this.RAPresetTab.Database = 'Client'
            }
            this.RAPresetDialog = true
        },
        AddalltoRADB(){
            //console.log(this.ContentBlocks)
            let ExcludedCats = ['Titles','Text','Images','Gallery']
            let ExcludedBlocks = ['Store Products']
            let filteredContentBlocks = this.ContentBlocks.filter(block => {
                return !block.SectionType && !block.DataViewName && !ExcludedCats.includes(block.Category) && !ExcludedBlocks.includes(block.Name)
            })
            console.log(filteredContentBlocks,filteredContentBlocks.map(block => {return block.Name}))
            
            this.AddingBlocks = filteredContentBlocks.map(block => {
                let blanktab = {	
                Category: block.Category,
                Preset_Name: block.Name,
                StaticVariables: [],					
                Open: true,									
                SectionType: true,									
                Transparent: true,									
                Alignment: 'center',									
                Justify: 'justify-center',									
                RowTransparency: 'transparent',									
                Name: 'blank',									
                Elements: [block],									
                ShowComponents: true,									
                FlexXLRG:11,									
                FlexLarge: 11,									
                FlexMedium: 11,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                }
                return blanktab
            })
            this.BulkContenttoPresetIndex = 0
            this.RAPresetTab = Object.assign({},this.AddingBlocks[this.BulkContenttoPresetIndex])
            this.BulkContentBlocktoPresetDialog = true
        },
        SlidebackDialog(){
            let elmnt = document.getElementById('selectedmaindial')
                if(this.MiniView){
                    elmnt.style.animation = 'slidetorghtmini 0.7s forwards'
                }
                else{
                    elmnt.style.animation = 'slidetorght 0.7s forwards'
                }
                
                setTimeout(() => {
                    this.SelectedMain = ''
                }, 700); 
        },
        AddCardBlockSingle(tab){
            let elements = tab.Elements
            let NewRow = {									
                Center: 'justify-center',									
                CenteredHeader: true,									
                Name: 'Card Block Single',									
                HeaderFontFamily: 'Roboto',									
                HeaderFontSize: 18,									
                HeaderColor: { "alpha": 1, "hex": "#162E4D", "hexa": "#162E4DFF", "hsla": { "h": 213.8181818181818, "s": 0.5555555555555557, "l": 0.1941176470588235, "a": 1 }, "hsva": { "h": 213.8181818181818, "s": 0.7142857142857143, "v": 0.30196078431372547, "a": 1 }, "hue": 213.8181818181818, "rgba": { "r": 22, "g": 46, "b": 77, "a": 1 } },									
                FontSize: 10,									
                FontColor: { "alpha": 1, "hex": "#162E4D", "hexa": "#162E4DFF", "hsla": { "h": 213.8181818181818, "s": 0.5555555555555557, "l": 0.1941176470588235, "a": 1 }, "hsva": { "h": 213.8181818181818, "s": 0.7142857142857143, "v": 0.30196078431372547, "a": 1 }, "hue": 213.8181818181818, "rgba": { "r": 22, "g": 46, "b": 77, "a": 1 } },									
                									
                Title: 'Here is a Headline',									
                Description: `<div style="text-align: center;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque non lacus nisi.</div>`,									
                FlexXLRG:2,									
                FlexLarge: 3,									
                FlexMedium: 3,									
                FlexSmall: 4,									
                FlexXSmall: 4,									
                Cols: 3,									
                Justify: 'justify-center',									
                RowColor: '#00ffff',									
                ShowComponents: true,									
                Icon: 'mdi-cards',									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                IsDark: true,									
                									
                									
            }									
            let colors = [									
                    '#F44336',									
                    '#E91E63',									
                    '#9C27B0',									
                    '#673AB7',									
                    '#3F51B5',									
                    '#2196F3',									
                    '#03A9F4',									
                    '#00BCD4',									
                    '#009688',									
                ]									
                let ranint = Math.floor(Math.random() * Math.floor(colors.length))									
                let length = elements.length									
                let twoback = length-2									
                if(length%2 != 0){									
                    if(elements[twoback] && elements[twoback].Type  && elements[twoback].Type === 1){									
                    NewRow.Title = ''									
                    NewRow.Description = '' 									
                    NewRow.HasImage = true									
                    NewRow.IMG = 'https://firebasestorage.googleapis.com/v0/b/templatizer-9620d.appspot.com/o/DefaultSystemAssets%2FExports%2FRAInvert-BG?alt=media&token=ed09e64f-d4ee-4948-b481-809495b3e236'									
                        NewRow.Type = 2									
                    }									
                    else{									
                    NewRow.Title = ''									
                    NewRow.Description = '' 									
                    NewRow.HasImage = true									
                    NewRow.IMG = 'https://firebasestorage.googleapis.com/v0/b/templatizer-9620d.appspot.com/o/DefaultSystemAssets%2FExports%2FRAInvert?alt=media&token=54d7ec67-2109-4eda-93c0-7bf98f55dbf8'									
                        NewRow.Type = 1									
                    }									
                }									
									
               									
                									
                NewRow.BGColor.hex = colors[ranint]									
                elements.push(NewRow)
                return elements
        },
        AddContentBlock(Previewblock,clientstored){
            let tab = ''
            if(clientstored){
                tab = Previewblock
            }
            else{
                tab = JSON.parse(JSON.stringify(this.RAStorePagePresets.find(obj => obj.id === Previewblock.id)))
            }
            //let tab = Object.assign({},this.RenderedContentBlocks.find(obj => obj.Name === Previewblock.Name))
            if(tab.Name === 'blank' && tab.Category !== 'Custom'){
                if(tab.Elements){
                    tab.Elements.map(elmnt => {
                        if(!elmnt.Preset_Name){
                            elmnt.Preset_Name = tab.Preset_Name
                        }
                    })
                }
            }
            console.log(tab)
            this.blockdragstart(tab)
            this.SelectedMainDialog = false
                this.SelectedMain = ''
                this.ActiveBlockClass = ''
            this.$store.commit('SetSocialItemInteractMethod','AddTabBelow')
        },
        
        PrepareSelectedMain(prop){
            let item = this.Computedsitenavitems.find(obj => obj.title === prop)
            //console.log(prop,this.Computedsitenavitems,item)
            if(item){
              this.ActivateSelectedMain(item)  
            }            
        },
        ActivateActiveBlockClass(clss){
            this.ActiveBlockClass = clss
        },
        DeactivateActiveBlockClass(){
            this.ActiveBlockClass = ''
        },
        OpenDialog(tab,tabindex,IsElement,CustomBoxTabIndex,isrow,rowindex,ContentDialog){
            let propobj = {
                tab: tab,tabindex: tabindex,IsElement: IsElement,CustomBoxTabIndex: CustomBoxTabIndex,isrow: isrow,rowindex: rowindex,ContentDialog: ContentDialog
            }
            this.$store.commit('SetSocialItemInteractMethodProp',propobj) 
            this.$store.commit('SetSocialItemInteractMethod','OpenDialogCustom')
        },
        AppPluginsMatched(categorymatches){
            let finalcategories = categorymatches.map(cat => {
          return cat.split(' & ')
        }).flat()
        return this.RAPlugins.filter(plug => {
          let plugcat = plug.Module_Category.Name.split(' & ').flat()
          return finalcategories.some(r=> plugcat.includes(r))
          //|| plug.Module_Category.Name === 'General'
        }).filter(item => {
           return item.Exclusively_as_Extension
        }).filter(plug => {
          let newappplugins = this.ActiveSuiteApp.Plugins.map(plug => {
            return plug.id
          })
          //console.log(newappplugins)
          return !newappplugins.includes(plug.id)
        })
        },
        RAPluginsMatched(categorymatches){
        let finalcategories = categorymatches.map(cat => {
          return cat.split(' & ')
        }).flat()
        return this.PurchasablePlugins.filter(plug => {
          let plugcat = plug.Module_Category.Name.split(' & ').flat()
          return finalcategories.some(r=> plugcat.includes(r))
          || plug.Module_Category.Name === 'General'
        }).filter(item => {
            if(this.DataSingleBuilder){
                return item.Exclusively_as_Extension
            }
            else{
                return item
            }
        })
      },
        PrepareActivateFullGallery(prop){
            this.$store.commit('setIMGProp','AppStylingIMG')
            this.AppStylingIMGProp = prop
            this.ActivateFullGallery()
        },
        AssignImageandCloseTab(){
            if(this.IsGroupView){
                this.ActiveGroup[this.AppStylingIMGProp] = this.SelectedImage
            }
            else{
                this.System[this.AppStylingIMGProp] = this.SelectedImage
            }
        },
        UpdateGroupStyling(){
      if(this.ActiveGroup.NavBar_IMG){
         db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).update({
          NavBar_IMG: this.ActiveGroup.NavBar_IMG
        })
      }     
      if(this.ActiveGroup.NavbarTextColor){
        db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).update({
          NavbarTextColor: this.ActiveGroup.NavbarTextColor
        })
      }
      if(this.ActiveGroup.NavbarBGColor){
        db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).update({
          NavbarBGColor: this.ActiveGroup.NavbarBGColor
        })
      }
      if(this.ActiveGroup.NavItemsBGColor){
        db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).update({
          NavItemsBGColor: this.ActiveGroup.NavItemsBGColor
        })
      }
      if(this.ActiveGroup.NavItemsTextColor){
        db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).update({
          NavItemsTextColor: this.ActiveGroup.NavItemsTextColor
        })
      }
      
    },
        SetColorstoSystemColors(System){
            this.$emit('SetColorstoSystemColors',System)
        },
        
        PrepareAddressField(fieldname,obj){
        let field = this[fieldname]
        
        field.FieldBreakdown = []
        let StreetNumber = {Name: field.Name+'_Street_Number',DisplayName: 'Street Number', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: '', SampleText: '1'}
        let StreetName = {Name: field.Name+'_Street_Name',DisplayName: 'Street Name', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: '', SampleText: 'Long Street'}
        let Suburb = {Name: field.Name+'_Suburb',DisplayName: 'Suburb', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: true, IsFilter: true, SampleText: 'SmallVille'}
        let City = {Name: field.Name+'_City',DisplayName: 'City', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: true, IsFilter: true, SampleText: 'Big Town'}
        let PostalCode = {Name: field.Name+'_Postal_Code',DisplayName: 'Postal Code', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: true, SampleText: '1777'}
        let StateProvince = {Name: field.Name+'_State_Province',DisplayName: 'State Province', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: true, IsFilter: true, SampleText: 'FarmState'}
        let CountryRegion = {Name: field.Name+'_Country_Region',DisplayName: 'Country Region', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: true, IsFilter: true, SampleText: 'DisneyLand'}
        field.FieldBreakdown = []
        field.FieldBreakdown.push(StreetNumber)
        field.FieldBreakdown.push(StreetName)
        field.FieldBreakdown.push(Suburb)
        field.FieldBreakdown.push(City)
        field.FieldBreakdown.push(PostalCode)
        field.FieldBreakdown.push(StateProvince)
        field.FieldBreakdown.push(CountryRegion)
        field.Response = {
            [field.Name+'_Street_Number'] : obj[field.Name+'_Street_Number'],
            [field.Name+'_Street_Name'] : obj[field.Name+'_Street_Name'],
            [field.Name+'_Suburb'] : obj[field.Name+'_Suburb'],
            [field.Name+'_City'] : obj[field.Name+'_City'],
            [field.Name+'_Postal_Code'] : obj[field.Name+'_Postal_Code'],
            [field.Name+'_State_Province'] : obj[field.Name+'_State_Province'],
            [field.Name+'_Country_Region'] : obj[field.Name+'_Country_Region']
        }
        //console.log(obj,obj[field.Name+'_Street_Number'],field.Name+'_Street_Number',StreetNumber,field.Response)
      },
        ActiveSiteInfoDialog(){
            let dbref = ''
            let recordobj = this[this.NavlistHolder]
            this.PrepareAddressField('Company_Address',this[this.NavlistHolder])
            if(this.IsGroupView){
                dbref = db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID)
                this.$store.commit('setMiniRecordDialogDescription',`<p>Update basic Site Information such as a general Description, Contact Information, and Location</p>`)
                 if(this.ActiveGroup && this.ActiveGroup.logo){
                    this.$store.commit('setMiniRecordDialogIMG',this.ActiveGroup.logo)
                }
                else{
                    this.$store.commit('setMiniRecordDialogIMG',require('@/assets/logo.png'))
                } 
            }
            else {
                dbref = db.collection('Websites').doc(this.$store.state.ActiveSuiteid)
                this.$store.commit('setMiniRecordDialogDescription',`<p>Update basic Site Information such as  general Description, Contact Information, and Location</p>`)               
                this.$store.commit('setMiniRecordDialogIMG',require('@/assets/logo.png')) 
            }
            this.$store.commit('setMiniRecordPath',dbref)
            let tab1fields = [
                {Name: 'Telephone', DisplayName: 'Telephone',Type: 'Common Field',CommonFieldType: 'Telephone Number'},
                 {Name: 'KeyWords', DisplayName: 'KeyWords',Type: 'Text Array',Response: []},
                {Name: 'Description', DisplayName: 'Description',text: 'Description',Type: 'Multiple Lines Text',IsContentEditable: true},
            ]
            let tab2fields = [
                this.Company_Address,
                {id: 'Published',Name: 'Published',DisplayName: 'Publish',Type: 'Boolean'}
            ]
            let tab3fields = [
                //KeyWords multiple array
            ]
            let tab4fields = [
                //embed window item IFRAME baby
            ]
            let allfields = tab1fields.concat(tab2fields,tab3fields,tab4fields)
            allfields.map(field => {
                console.log(field.Name,this[this.NavlistHolder][field.Name])
                if(typeof this[this.NavlistHolder][field.Name] !== 'undefined'){
                    field.Response = this[this.NavlistHolder][field.Name]
                }
            })
            let tabs = [
               { Name: 'General', FormFields: tab1fields},
               { Name: 'Location', FormFields: tab2fields}
            ]
            
            
            this.$store.commit('setMiniRecordTabs',tabs)
            this.$store.commit('setMiniRecordDialogTitle','Site Information')            
            this.$store.commit('setMiniRecordObject',recordobj)                       
            this.$store.commit('setMiniRecordDialog',true)
        },
        CancelDrag(){
            this.$store.commit('setdragging','') 
        },
        blockdragstart(block) {									
        //console.log(block)	
        this.$store.commit('setdragging',block) 								
        },
        HideTabElements(i){
            this.$store.commit('SetSocialItemInteractMethodProp',i) 
            this.$store.commit('SetSocialItemInteractMethod','HideTabElements')
        },
        ShowTabElements(i){
            //console.log(i)
            this.$store.commit('SetSocialItemInteractMethodProp',i) 
            this.$store.commit('SetSocialItemInteractMethod','ShowTabElements')
        },
        Elmntdragstart(tab,tabindex,elmnt,elmntindex){		
            //console.log(tab,tabindex,elmnt,elmntindex)	
            this.$store.commit('setdraggingtab',tab) 
            this.$store.commit('setdraggingtabindex',tabindex)
            this.$store.commit('setdraggingelement',elmnt)
            this.$store.commit('setdraggingelementindex',elmntindex)								
        },									
        Elmntdragfinish(to){
            //to is now payload with tab,i,elmnt,elmntindex	
            this.$store.commit('SetSocialItemInteractMethodProp',to)
            this.$store.commit('SetSocialItemInteractMethod','Elmntdragfinish')
        },
        Tabdragstart(row,rowindex){									
            this.$store.commit('setdraggingrow',row) 
            this.$store.commit('setdraggingrowindex',rowindex)				
        },									
        Tabdragfinish(to,ev){	
            this.$store.commit('SetSocialItemInteractMethodProp',to) 
            this.$store.commit('SetSocialItemInteractMethod','Tabdragfinish')								
            this.PageTabs.splice(to, 0, this.PageTabs.splice(this.draggingrowindex, 1)[0]);	
            this.$store.commit('SetSocialItemInteractMethodProp',to)
            this.$store.commit('SetSocialItemInteractMethod','Tabdragfinish')						
        },	
        GetGalleryObjects(){									
            let routes = this.$router.getRoutes()									
            let GalleryPaths = routes.filter(option => {return option.meta && option.meta.photolibrary})									
           //console.log('GalleryPaths',GalleryPaths)									
            GalleryPaths.map(path => {	
                let check = this.GalleryLibraries.find(obj => obj.name === path.meta.subcat)									
                if(!check){		
                    let libraryobj = {									
                        name: path.meta.subcat,									
                        compname: path.meta.subcat.split(' ').join(''),									
                        Assets: [],								
                    }	
                    let libentity = this.SystemPhotoLibraries.find(obj => obj.id === path.meta.EntityID)	
                    if(libentity){
                        if(libentity.CustomTags){
                            libraryobj.CustomTags = libentity.CustomTags  
                            libraryobj.EntityCollectionRef = db.collection('Libraries').doc(this.$store.state.ActiveSuiteid).collection('PhotoLibraries').doc(libentity.id)	
                        }
                        libraryobj.TableCollectionRef = db.collection(libentity.id.split('_').join('').toLowerCase())
                        this.GalleryLibraries.push(libraryobj)	
                        this.GetGalleryItems(path)                                    
                    }
                }
                else{
                    this.GetGalleryItems(path) 
                }						
            })									
        },									
        GetGalleryItems(path){	
            let assetref = db.collection('Libraries').doc(this.$store.state.ActiveSuiteid).collection('PhotoLibraries').doc(path.meta.id).collection('Assets')								
            assetref.onSnapshot(res => {									
                        const changes = res.docChanges();									
                        changes.forEach(change => {									
                          if (change.type === 'added') {									
                              let returnobj = {									
                              ...change.doc.data(),									
                              id: change.doc.id									
                            }									
                            //console.log(typeof this.SystemAssets)									
                            // returnobj.Library = path.meta.subcat									
                            let check = this.GalleryLibraries.find(obj => obj.name === path.meta.subcat)									
                            check.Assets.push(returnobj)									
                            //console.log(this.GalleryLibraries)									
                            									
                          }									
                        })									
                      })									
        },	
        PrepNavbar(newvalue){
            if(this.IsGroupView){
                this.SelectedNavbar = this.NavbarItems.find(obj => obj.Name === 'Group')
            }
            else {									
                this.PublishType = 'Public'
                this.SelectedNavbar = this.NavbarItems.find(obj => obj.Name === 'Public')								
            }
        },
        //['ShowTabElements','HideTabElements','OpenDialog','AdjustRowAmount','Elmntdragstart','Elmntdragfinish','NoPropsemit','blockdragstart']
        // /AssignSocialItemInteractMethod(item,SecondProp)

        CancelNavItemDrag(){
            this.NavItemIndex = -1
        },
        NavItemDragStart(index){
            this.NavItemIndex = index
        },		
        NavItemDragFinish(index){
            this.NavListArray.splice(index,0, this.NavListArray.splice(this.NavItemIndex, 1)[0])
        },
        UpdateContentEditableField(prop,value,AdditionalSaveMethod,FieldObject){
            FieldObject[prop] = value
            console.log(AdditionalSaveMethod)
            if(AdditionalSaveMethod){
                this[AdditionalSaveMethod]()
            }
        },
        DeactivateSEODialog(){
            this.SEOBasicsDialog = false
            this.SEOPage = Object.assign({},this.DefaultSEOPage)
        },
        UpdateSEOBasics(){
            let updatepath = ''
            if(this.$route.name === 'PageEditor'){
                updatepath = this.SEOPage && this.SEOPage.PublishType === 'Public' ? db.collection('Websites').doc(this.$store.state.ActiveSuiteid).collection('Pages').doc(this.SEOPage.id) :
                db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('Pages').doc(this.SEOPage.id)
            }
            else if(this.IsGroupView){
                updatepath = db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).collection('pages').doc(this.SEOPage.id)
            }
            updatepath.update({
                Overview: this.SEOPage.Overview,
                KeyWords: this.SEOPage.KeyWords,
                SEO: this.SEOPage.SEO
            }).then(updatedpage => {
                this.DeactivateSEODialog()
            })
        },
        ConfirmPageTransfer(page){
            //We will allow this later but have to consider things like the content on the page, and plugins on it, ensure no clash between module plugins
            //and dissecting things like social channel read type etc

            let publicmsg = 'Website ("Public" - visible to everybody on Internet)'
            let membersmsg = 'Social Network ("Members Only" - Visible only to Signed in Users)'
            let oldtype = page.PublishType === 'Public' ? publicmsg : membersmsg
            let newtype = page.PublishType === 'Public' ? membersmsg : publicmsg
            let pagename = page.Name.toUpperCase()
            confirm('This will convert this page "'+pagename+'" from the '+oldtype+' to the '+newtype+'. Are you sure you want to proceed?') && this.PageTransfer(page)
        },
        PageTransfer(page){
            let oldtype = page.PublishType
            let newtype = oldtype === 'Public' ? 'Members Only' : 'Public'
            let webref = db.collection('Websites').doc(this.$store.state.ActiveSuiteid).collection('Pages').doc(page.id)
            let socialref = db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('Pages').doc(page.id)
            let oldref =  oldtype === 'Public' ? webref : socialref
            let newref = oldtype === 'Public' ? socialref : webref
            let newpage = {
                ...page,
                PublishType: newtype,
                OriginalType: oldtype
            }
            newref.set(newpage).then(newdoc => {
                oldref.update({
                    PublishType: newtype,
                    Transferred: true
                })
            })


        },
        ActivateSEOBasicsDialog(page){
            this.SEOPage = {
                Overview: page.Overview,
                KeyWords: [],
                PageRoute: page.PageRoute,
                Name: page.Name,
                Icon: page.PageIcon,
                id: page.id,
                SEO: false,
            }
            if(page.KeyWords){
                this.SEOPage.KeyWords = page.KeyWords
            }
            if(page.SEO){
                this.SEOPage.SEO = page.SEO
            }
            this.SEOBasicsDialog = true
        },
        ChangePageProp(page,Prop){
        },
        UpdatePageProp(page,Prop){
            let updatepath = ''
            if(this.$route.name === 'PageEditor'){
                updatepath = page.PublishType === 'Members Only' ? db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('Pages').doc(page.id)
                : db.collection('Websites').doc(this.$store.state.ActiveSuiteid).collection('Pages').doc(page.id)
            }
            else if(this.IsGroupView){
                updatepath = db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).collection('pages').doc(page.id)
            }
            updatepath.update({
                [Prop]: page[Prop]
            })
        },
        ActivatePageBGDialog(){
            this.$store.commit('setGalleryLibraries',this.GalleryLibraries)
            this.$store.commit('setGalleryAssets',this.SystemAssets)
            this.$store.commit('setEditedTab','')
            this.$store.commit('setIMGProp','PageBGAsset')
            this.$store.commit('SetSocialItemInteractMethod','ToggleGalleryDialog')
        },
        ActivateFullGallery(){
            this.$store.commit('setGalleryLibraries',this.GalleryLibraries)
            this.$store.commit('setGalleryAssets',this.SystemAssets)
            this.$store.commit('setEditedTab','')
            this.$store.commit('SetSocialItemInteractMethod','ToggleGalleryDialog')
        },
        RemovePagefromNavlistArray(page){
            let item = this[this.NavlistHolder][this.SelectedNavbar.Prop].find(obj => obj.title === page.Name)
            if(item){
                item.OnMenu = false
                item.MenuIndex = 100000
                let index = this[this.NavlistHolder][this.SelectedNavbar.Prop].indexOf(item)
                this[this.NavlistHolder][this.SelectedNavbar.Prop].splice(index,1)
            }
            this.SelectedMainDialog = false
            setTimeout(() => {
                    this.SelectedMainDialog = true
            }, 10);
        },
        PushPagetoNavlistArray(page){
            if(!this[this.NavlistHolder][this.SelectedNavbar.Prop]){
                this[this.NavlistHolder][this.SelectedNavbar.Prop] = []
            }
            let navpage = {
                id: page.id,
                Path: page.PageRoute,
                title: page.Name,
                MenuIndex: this[this.NavlistHolder][this.SelectedNavbar.Prop].length
            }
            if(page.PageIcon){
                navpage.icon = page.PageIcon
            }
            
            this[this.NavlistHolder][this.SelectedNavbar.Prop].push(navpage)
            this.SelectedMainDialog = false
            setTimeout(() => {
                    this.SelectedMainDialog = true
            }, 10);
            // console.log('this.SelectedNavbar',this.SelectedNavbar)
            // console.log(this[this.NavlistHolder],this[this.NavlistHolder][this.SelectedNavbar.Prop],this.NavListArray)
        },
        UpdateMenu(){
            console.log('this.NavListArray',this.NavListArray)
            if(this.NavListArray){
             this.NavlistRef.update({
                [this.SelectedNavbar.Prop]: this.NavListArray
            })   
            }
            
        },
        PageClass(page){
            if(this.SelectedPage.Name === page.Name){
                if(this.$vuetify.theme.dark){
                   return 'background lighten-2 sitenavitem' 
                }                
            }
            else{
                if(this.$vuetify.theme.dark){
                return 'background sitenavitem'
                }
                else{
                 return 'sitenavitem'   
                }
            }
        },
        
        AddNewPage(navbar){
            console.log(navbar)
            let pageitems =  [{
            title: 'Create Website Page',
            icon: 'mdi-search-web',
            ItemPass: true,
            Method: 'AssignSocialItemInteractMethod',
            Prop: 'ToggleNewPageDialog',
            SecondProp: 'Public'
          },
          {
            title: 'Create Social Page',
            icon: 'mdi-search-web',
            ItemPass: true,
            Method: 'AssignSocialItemInteractMethod',
            Prop: 'ToggleNewPageDialog',
            SecondProp: 'Members Only'
          },]
          if(this.$route.name === 'GroupPageEditor'){
              let pubtype = ''
              if(this.ActiveGroup.GroupPrivacy === 'Public'){
                  pubtype = 'Public'
              }
              else{
                  pubtype = 'Members Only'
              }
              this.AssignSocialItemInteractMethod('ToggleNewPageDialog',pubtype)
          }
          else{
              let item = pageitems.find(obj => obj.SecondProp === navbar.PublishType)
              this.AssignSocialItemInteractMethod('ToggleNewPageDialog',navbar.PublishType)
          }
        },
        AssignSocialItemInteractMethod(item,SecondProp){
        //console.log('AssignSocialItemInteractMethod',item,SecondProp)
        this.$store.commit('SetSocialItemInteractMethodProp','') 
        this.$store.commit('SetSocialItemInteractMethod','')
        if(SecondProp){
            this.$store.commit('SetSocialItemInteractMethodProp',SecondProp) 
            this.$store.commit('SetSocialItemInteractMethod',item)
        }
        else if(item){
            this.$store.commit('SetSocialItemInteractMethod',item)
        }
        },
        
        ActivateSelectedMain(main,frompredial){
            //console.log(main,frompredial)
            if(main.title === 'Web Forms' && frompredial){
                this.NavigatetoWebFormBuilder()
            }
            else if(main.PreDialog && !frompredial){
                this.SelectedMain = main
            }
            else if(main.SecondProp && main.SecondProp.PreDialog && !frompredial){
                this.SelectedMain = main
            }
            else if(main.Method){
                this.SelectedMainDialog = false
                this.SelectedMain = ''
             this.AssignSocialItemInteractMethod(main.Prop,main.SecondProp)   
            }
            else if(main.Route){
                this.$router.push('/'+main.Route)
            }
            else{
                this.SelectedMain = main
            }
        },
        NavigatetoWebFormEditor(entityid){
             if(entityid !== this.$route.params.id){
                if(this.IsGroupView){
                    this.$router.replace({name: 'GroupWebFormEditor', query: {GroupID: this.GroupID},params: {id: entityid}})  
                }
                else{
                    this.$router.push('/WebFormEditor/'+entityid)
                }
             }        
        },
        NavigatetoWebFormBuilder(){
            if(this.IsGroupView){
             this.$router.replace({name: 'GroupWebFormBuilder', query: {GroupID: this.GroupID}})   
            }
            else{
                this.$router.push('/WebFormBuilder-New')
            }
            
            // let routeData = this.$router.resolve({name: 'GroupWebFormBuilder', query: {GroupID: this.GroupID}});
            // window.open(routeData.href, '_blank');
        },
        SelectOtherPage(page){
            this.EditOtherPage(page)
        },
        EditOtherPage(SelectedPage){
            if(this.IsGroupView){
                this.$router.push('/Group-PageEditor/'+this.GroupID+'/'+SelectedPage.id)
            }
            else{
                this.$router.push('/PageEditor/'+SelectedPage.id)
            }
        },
        
        AddContentDialog(EditedTab){
            if(EditedTab.ContentDialogType){
                let contentbox = this.ContentBlocks.find(obj => obj.Name === EditedTab.ContentDialogType.Name)
                EditedTab.ContentDialogBox = Object.assign({},contentbox)
                EditedTab.ContentDialogBox.Elevation = 0
                EditedTab.ContentDialogBox.Tile = true
                EditedTab.ContentDialogBox.Flat = true
                EditedTab.ContentDialogBox.IsContentDialog = true
            }
        },
    }
}
</script>

<style>
.navslide {
    position: absolute;
    left: -100px;
    width: 100px;
    height: 100px;
    background: blue;
    -webkit-animation: slidefromlft 0.5s forwards;
    animation: slidefromlft 0.5s forwards;
}

@-webkit-keyframes slidefromlft {
    0% { left: -1000px; }
    100% { left: 88px; }
}

@keyframes slidefromlft {
    0% { left: -1000px; }
    100% { left: 88px; }
}
@-webkit-keyframes slidetorght {
    0% { left: 88px; }
    100% { left: -1000px; }
}

@keyframes slidetorght {
    0% { left: 88px; }
    100% { left: -1000px; }
}
@-webkit-keyframes slidefromlftmini {
    0% { left: -1000px; }
    100% { left: 0px; }
}

@keyframes slidefromlftmini {
    0% { left: -1000px; }
    100% { left: 0px; }
}
@-webkit-keyframes slidetorghtmini {
    0% { left: 0px; }
    100% { left: -1000px; }
}

@keyframes slidetorghtmini {
    0% { left: 0px; }
    100% { left: -1000px; }
}
@-webkit-keyframes slidefromlftsub {
    0% { left: -400px; }
    100% { left: 0px; }
}

@keyframes slidefromlftsub {
    0% { left: -400px; }
    100% { left: 0px; }
}
@-webkit-keyframes slidetorghtsub {
    0% { left: 0px; }
    100% { left: -400px; }
}

@keyframes slidetorghtsub {
    0% { left: 0px; }
    100% { left: -400px; }
}


</style>



